/* tslint:disable */
/* eslint-disable */
/**
 * YubiEnterprise API
 * The YubiEnterprise API provides capabilities to manage your organization, users, and shipments.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface AccountBalances
 */
export interface AccountBalances {
    /**
     * 
     * @type {Array<ShippingAccount>}
     * @memberof AccountBalances
     */
    'shipping'?: Array<ShippingAccount>;
    /**
     * 
     * @type {Array<TaxAccount>}
     * @memberof AccountBalances
     */
    'tax'?: Array<TaxAccount>;
    /**
     * 
     * @type {Array<VATAccount>}
     * @memberof AccountBalances
     */
    'vat'?: Array<VATAccount>;
}
/**
 * 
 * @export
 * @interface Address
 */
export interface Address {
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'street_line1': string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'street_line2'?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     * @deprecated
     */
    'street_line3'?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'city': string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'postal_code': string;
    /**
     * Required if `country_code_2` is either \"US\" or \"CA\"
     * @type {string}
     * @memberof Address
     */
    'region'?: string;
    /**
     * ISO-3166-2 country code.
     * @type {string}
     * @memberof Address
     */
    'country_code_2': string;
}
/**
 * 
 * @export
 * @interface AddressValidationResponse
 */
export interface AddressValidationResponse {
    /**
     * 
     * @type {string}
     * @memberof AddressValidationResponse
     */
    'status'?: string;
    /**
     * 
     * @type {Array<AddressValidationResponseDetailsInner>}
     * @memberof AddressValidationResponse
     */
    'details'?: Array<AddressValidationResponseDetailsInner>;
    /**
     * 
     * @type {Address}
     * @memberof AddressValidationResponse
     */
    'address'?: Address;
}
/**
 * 
 * @export
 * @interface AddressValidationResponseDetailsInner
 */
export interface AddressValidationResponseDetailsInner {
    /**
     * 
     * @type {string}
     * @memberof AddressValidationResponseDetailsInner
     */
    'description'?: string;
}
/**
 * 
 * @export
 * @interface AmountsPerCustomization
 */
export interface AmountsPerCustomization {
    /**
     * The customization ID. Null indicates a standard configuration (i.e. no customization). There might be more than one customization to choose from for the same product ID. 
     * @type {string}
     * @memberof AmountsPerCustomization
     */
    'customization_id': string | null;
    /**
     * Total number of keys purchased with this customization ID
     * @type {number}
     * @memberof AmountsPerCustomization
     */
    'amount_total': number;
    /**
     * Number of keys remaining with this customization ID
     * @type {number}
     * @memberof AmountsPerCustomization
     */
    'amount_remaining': number;
    /**
     * Number of keys possible to ship out right now with this customization ID
     * @type {number}
     * @memberof AmountsPerCustomization
     */
    'amount_shippable': number;
}
/**
 * 
 * @export
 * @interface AuthProfile
 */
export interface AuthProfile {
    /**
     * 
     * @type {string}
     * @memberof AuthProfile
     */
    'first_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof AuthProfile
     */
    'last_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof AuthProfile
     */
    'email'?: string;
}
/**
 * 
 * @export
 * @interface AuthSetActiveOrgPostRequest
 */
export interface AuthSetActiveOrgPostRequest {
    /**
     * 
     * @type {string}
     * @memberof AuthSetActiveOrgPostRequest
     */
    'org_id': string;
}
/**
 * 
 * @export
 * @interface AuthUser
 */
export interface AuthUser {
    /**
     * 
     * @type {boolean}
     * @memberof AuthUser
     */
    'accepted_terms'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AuthUser
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof AuthUser
     */
    'external_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof AuthUser
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof AuthUser
     */
    'active_token'?: string;
    /**
     * 
     * @type {AuthProfile}
     * @memberof AuthUser
     */
    'profile'?: AuthProfile;
    /**
     * Deprecated: The use of this property is not recommended. Use orgs instead. The value will be the first of the available roles of the user given the current organization and authentication method. 
     * @type {{ [key: string]: string; }}
     * @memberof AuthUser
     * @deprecated
     */
    'roles'?: { [key: string]: string; };
    /**
     * 
     * @type {{ [key: string]: OrgInfo; }}
     * @memberof AuthUser
     */
    'orgs'?: { [key: string]: OrgInfo; };
    /**
     * This field is deprecated and will be removed in the future
     * @type {boolean}
     * @memberof AuthUser
     * @deprecated
     */
    'demo_mode'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AuthUser
     */
    'org'?: string;
    /**
     * Deprecated: The use of this property is not recommended. Use orgs instead.
     * @type {string}
     * @memberof AuthUser
     * @deprecated
     */
    'role'?: string;
    /**
     * 
     * @type {TokenMetadata}
     * @memberof AuthUser
     */
    'token_metadata'?: TokenMetadata;
    /**
     * The use of this property is not recommended, as it is an experimental field that is likely to change. True when the user has one or more mfa registered. 
     * @type {boolean}
     * @memberof AuthUser
     */
    'mfa_registered'?: boolean;
    /**
     * The use of this property is not recommended, as it is an experimental field that is likely to change. True when the user has password registered. 
     * @type {boolean}
     * @memberof AuthUser
     */
    'password_registered'?: boolean;
    /**
     * The use of this property is not recommended, as it is an experimental field that is likely to change. True when the user has migrated to passwordless authentication. 
     * @type {boolean}
     * @memberof AuthUser
     */
    'passwordless_migrated'?: boolean;
    /**
     * The use of this property is not recommended, as it is an experimental field that is likely to change. The number of passkeys a user has registered. 
     * @type {number}
     * @memberof AuthUser
     */
    'passkey_count'?: number;
    /**
     * 
     * @type {PasskeyComplianceStatus}
     * @memberof AuthUser
     */
    'compliance_status'?: PasskeyComplianceStatus;
    /**
     * The use of this property is not recommended, as it is an experimental field that is likely to change.
     * @type {string}
     * @memberof AuthUser
     */
    'authentication_method'?: string;
}


/**
 * The carrier used to deliver a shipment
 * @export
 * @enum {string}
 */

export enum CarrierIdentifierEnum {
    BlueDart = 'bluedart',
    DPD = 'dpd',
    FedEx = 'fedex',
    FedExSameDay = 'fedex same day',
    Others = 'others',
    TecEx = 'tecex',
    IndiaPost = 'india-post',
    PitneyBowes = 'pitney bowes',
    RoyalMail = 'royal mail',
    Transnet = 'transnet',
    UPS = 'ups',
    USPS = 'usps',
    Unknown = 'coming soon'
}


/**
 * 
 * @export
 * @interface ChannelPartner
 */
export interface ChannelPartner {
    /**
     * 
     * @type {number}
     * @memberof ChannelPartner
     */
    'channelpartner_id': number;
    /**
     * 
     * @type {string}
     * @memberof ChannelPartner
     */
    'channelpartner_name': string;
    /**
     * 
     * @type {string}
     * @memberof ChannelPartner
     */
    'organization_id': string;
}
/**
 * 
 * @export
 * @interface ChannelPartnerResultSet
 */
export interface ChannelPartnerResultSet {
    /**
     * 
     * @type {number}
     * @memberof ChannelPartnerResultSet
     */
    'count'?: number;
    /**
     * 
     * @type {number}
     * @memberof ChannelPartnerResultSet
     */
    'total_count'?: number;
    /**
     * 
     * @type {Array<ChannelPartner>}
     * @memberof ChannelPartnerResultSet
     */
    'channelpartners'?: Array<ChannelPartner>;
}
/**
 * 
 * @export
 * @interface Configurations
 */
export interface Configurations {
    /**
     * 
     * @type {boolean}
     * @memberof Configurations
     */
    'supports_fido2_preregistration': boolean;
}
/**
 * 
 * @export
 * @interface Country
 */
export interface Country {
    /**
     * 
     * @type {number}
     * @memberof Country
     */
    'country_id': number;
    /**
     * 
     * @type {string}
     * @memberof Country
     */
    'country_name': string;
    /**
     * 
     * @type {string}
     * @memberof Country
     */
    'country_code_2': string;
    /**
     * 
     * @type {string}
     * @memberof Country
     */
    'country_code_3': string;
    /**
     * 
     * @type {number}
     * @memberof Country
     */
    'country_vat_rate': number;
    /**
     * 
     * @type {Array<DeliveryTypeResponse>}
     * @memberof Country
     */
    'delivery_types': Array<DeliveryTypeResponse>;
}
/**
 * 
 * @export
 * @interface CountryResultSet
 */
export interface CountryResultSet {
    /**
     * 
     * @type {number}
     * @memberof CountryResultSet
     */
    'count'?: number;
    /**
     * 
     * @type {number}
     * @memberof CountryResultSet
     */
    'total_count'?: number;
    /**
     * 
     * @type {Array<Country>}
     * @memberof CountryResultSet
     */
    'countries'?: Array<Country>;
}
/**
 * 
 * @export
 * @interface CustomerPurchaseOrderResponse
 */
export interface CustomerPurchaseOrderResponse {
    /**
     * 
     * @type {number}
     * @memberof CustomerPurchaseOrderResponse
     */
    'channelpartner_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof CustomerPurchaseOrderResponse
     */
    'channelpartner_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerPurchaseOrderResponse
     */
    'closing_city'?: string;
    /**
     * 
     * @type {number}
     * @memberof CustomerPurchaseOrderResponse
     */
    'closing_country_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof CustomerPurchaseOrderResponse
     */
    'closing_postal_code'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerPurchaseOrderResponse
     */
    'closing_region'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerPurchaseOrderResponse
     */
    'closing_street_line1'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerPurchaseOrderResponse
     */
    'closing_street_line2'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerPurchaseOrderResponse
     * @deprecated
     */
    'closing_street_line3'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerPurchaseOrderResponse
     */
    'closing_country_code_2'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CustomerPurchaseOrderResponse
     */
    'is_closed'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CustomerPurchaseOrderResponse
     */
    'is_post_pay'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CustomerPurchaseOrderResponse
     */
    'is_tax_exempt'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CustomerPurchaseOrderResponse
     */
    'is_vat_valid'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CustomerPurchaseOrderResponse
     */
    'vat_number'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CustomerPurchaseOrderResponse
     */
    'allow_automated_shipments': boolean;
    /**
     * 
     * @type {string}
     * @memberof CustomerPurchaseOrderResponse
     */
    'key_contact'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerPurchaseOrderResponse
     */
    'key_contact_email'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerPurchaseOrderResponse
     */
    'key_contact_phone_number'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerPurchaseOrderResponse
     */
    'order_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerPurchaseOrderResponse
     * @deprecated
     */
    'organization_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerPurchaseOrderResponse
     */
    'organization_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerPurchaseOrderResponse
     */
    'organizations_shippingaccount_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerPurchaseOrderResponse
     */
    'organizations_taxaccount_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerPurchaseOrderResponse
     */
    'organizations_vataccount_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerPurchaseOrderResponse
     */
    'purchaseorder_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerPurchaseOrderResponse
     */
    'purchaseorder_number'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerPurchaseOrderResponse
     */
    'yubicoorder_number'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerPurchaseOrderResponse
     */
    'yubicoinvoice_number'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerPurchaseOrderResponse
     */
    'purchaseorder_state_message'?: string;
    /**
     * 
     * @type {number}
     * @memberof CustomerPurchaseOrderResponse
     */
    'purchaseorder_state_id'?: number;
    /**
     * 
     * @type {number}
     * @memberof CustomerPurchaseOrderResponse
     */
    'shipping_credit_purchased'?: number;
    /**
     * 
     * @type {number}
     * @memberof CustomerPurchaseOrderResponse
     */
    'shipping_credit_remaining'?: number;
    /**
     * 
     * @type {number}
     * @memberof CustomerPurchaseOrderResponse
     */
    'tax_credit_purchased'?: number;
    /**
     * 
     * @type {number}
     * @memberof CustomerPurchaseOrderResponse
     */
    'tax_credit_remaining'?: number;
    /**
     * 
     * @type {number}
     * @memberof CustomerPurchaseOrderResponse
     */
    'total_keys_purchased'?: number;
    /**
     * 
     * @type {number}
     * @memberof CustomerPurchaseOrderResponse
     */
    'total_keys_remaining'?: number;
    /**
     * 
     * @type {number}
     * @memberof CustomerPurchaseOrderResponse
     */
    'vat_credit_purchased'?: number;
    /**
     * 
     * @type {number}
     * @memberof CustomerPurchaseOrderResponse
     */
    'vat_credit_remaining'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CustomerPurchaseOrderResponse
     */
    'is_override_shipping'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CustomerPurchaseOrderResponse
     */
    'override_shipping_charge'?: number;
    /**
     * 
     * @type {number}
     * @memberof CustomerPurchaseOrderResponse
     */
    'override_shipping_key_limit'?: number;
    /**
     * 
     * @type {string}
     * @memberof CustomerPurchaseOrderResponse
     */
    'order_closing_date'?: string;
    /**
     * 
     * @type {CustomerPurchaseOrderResponseSummaryAllOfReseller}
     * @memberof CustomerPurchaseOrderResponse
     */
    'reseller': CustomerPurchaseOrderResponseSummaryAllOfReseller | null;
    /**
     * 
     * @type {Array<PurchaseOrderProductResponse>}
     * @memberof CustomerPurchaseOrderResponse
     */
    'order_items': Array<PurchaseOrderProductResponse>;
}
/**
 * 
 * @export
 * @interface CustomerPurchaseOrderResponseAllOf
 */
export interface CustomerPurchaseOrderResponseAllOf {
    /**
     * 
     * @type {Array<PurchaseOrderProductResponse>}
     * @memberof CustomerPurchaseOrderResponseAllOf
     */
    'order_items': Array<PurchaseOrderProductResponse>;
}
/**
 * 
 * @export
 * @interface CustomerPurchaseOrderResponseSet
 */
export interface CustomerPurchaseOrderResponseSet {
    /**
     * 
     * @type {number}
     * @memberof CustomerPurchaseOrderResponseSet
     */
    'count': number;
    /**
     * 
     * @type {number}
     * @memberof CustomerPurchaseOrderResponseSet
     */
    'total_count': number;
    /**
     * 
     * @type {Array<CustomerPurchaseOrderResponseSummary>}
     * @memberof CustomerPurchaseOrderResponseSet
     */
    'purchaseorders': Array<CustomerPurchaseOrderResponseSummary>;
}
/**
 * 
 * @export
 * @interface CustomerPurchaseOrderResponseSetAllOf
 */
export interface CustomerPurchaseOrderResponseSetAllOf {
    /**
     * 
     * @type {Array<CustomerPurchaseOrderResponseSummary>}
     * @memberof CustomerPurchaseOrderResponseSetAllOf
     */
    'purchaseorders': Array<CustomerPurchaseOrderResponseSummary>;
}
/**
 * 
 * @export
 * @interface CustomerPurchaseOrderResponseSummary
 */
export interface CustomerPurchaseOrderResponseSummary {
    /**
     * 
     * @type {number}
     * @memberof CustomerPurchaseOrderResponseSummary
     */
    'channelpartner_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof CustomerPurchaseOrderResponseSummary
     */
    'channelpartner_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerPurchaseOrderResponseSummary
     */
    'closing_city'?: string;
    /**
     * 
     * @type {number}
     * @memberof CustomerPurchaseOrderResponseSummary
     */
    'closing_country_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof CustomerPurchaseOrderResponseSummary
     */
    'closing_postal_code'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerPurchaseOrderResponseSummary
     */
    'closing_region'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerPurchaseOrderResponseSummary
     */
    'closing_street_line1'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerPurchaseOrderResponseSummary
     */
    'closing_street_line2'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerPurchaseOrderResponseSummary
     * @deprecated
     */
    'closing_street_line3'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerPurchaseOrderResponseSummary
     */
    'closing_country_code_2'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CustomerPurchaseOrderResponseSummary
     */
    'is_closed'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CustomerPurchaseOrderResponseSummary
     */
    'is_post_pay'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CustomerPurchaseOrderResponseSummary
     */
    'is_tax_exempt'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CustomerPurchaseOrderResponseSummary
     */
    'is_vat_valid'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CustomerPurchaseOrderResponseSummary
     */
    'vat_number'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CustomerPurchaseOrderResponseSummary
     */
    'allow_automated_shipments': boolean;
    /**
     * 
     * @type {string}
     * @memberof CustomerPurchaseOrderResponseSummary
     */
    'key_contact'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerPurchaseOrderResponseSummary
     */
    'key_contact_email'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerPurchaseOrderResponseSummary
     */
    'key_contact_phone_number'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerPurchaseOrderResponseSummary
     */
    'order_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerPurchaseOrderResponseSummary
     * @deprecated
     */
    'organization_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerPurchaseOrderResponseSummary
     */
    'organization_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerPurchaseOrderResponseSummary
     */
    'organizations_shippingaccount_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerPurchaseOrderResponseSummary
     */
    'organizations_taxaccount_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerPurchaseOrderResponseSummary
     */
    'organizations_vataccount_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerPurchaseOrderResponseSummary
     */
    'purchaseorder_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerPurchaseOrderResponseSummary
     */
    'purchaseorder_number'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerPurchaseOrderResponseSummary
     */
    'yubicoorder_number'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerPurchaseOrderResponseSummary
     */
    'yubicoinvoice_number'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerPurchaseOrderResponseSummary
     */
    'purchaseorder_state_message'?: string;
    /**
     * 
     * @type {number}
     * @memberof CustomerPurchaseOrderResponseSummary
     */
    'purchaseorder_state_id'?: number;
    /**
     * 
     * @type {number}
     * @memberof CustomerPurchaseOrderResponseSummary
     */
    'shipping_credit_purchased'?: number;
    /**
     * 
     * @type {number}
     * @memberof CustomerPurchaseOrderResponseSummary
     */
    'shipping_credit_remaining'?: number;
    /**
     * 
     * @type {number}
     * @memberof CustomerPurchaseOrderResponseSummary
     */
    'tax_credit_purchased'?: number;
    /**
     * 
     * @type {number}
     * @memberof CustomerPurchaseOrderResponseSummary
     */
    'tax_credit_remaining'?: number;
    /**
     * 
     * @type {number}
     * @memberof CustomerPurchaseOrderResponseSummary
     */
    'total_keys_purchased'?: number;
    /**
     * 
     * @type {number}
     * @memberof CustomerPurchaseOrderResponseSummary
     */
    'total_keys_remaining'?: number;
    /**
     * 
     * @type {number}
     * @memberof CustomerPurchaseOrderResponseSummary
     */
    'vat_credit_purchased'?: number;
    /**
     * 
     * @type {number}
     * @memberof CustomerPurchaseOrderResponseSummary
     */
    'vat_credit_remaining'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CustomerPurchaseOrderResponseSummary
     */
    'is_override_shipping'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CustomerPurchaseOrderResponseSummary
     */
    'override_shipping_charge'?: number;
    /**
     * 
     * @type {number}
     * @memberof CustomerPurchaseOrderResponseSummary
     */
    'override_shipping_key_limit'?: number;
    /**
     * 
     * @type {string}
     * @memberof CustomerPurchaseOrderResponseSummary
     */
    'order_closing_date'?: string;
    /**
     * 
     * @type {CustomerPurchaseOrderResponseSummaryAllOfReseller}
     * @memberof CustomerPurchaseOrderResponseSummary
     */
    'reseller': CustomerPurchaseOrderResponseSummaryAllOfReseller | null;
}
/**
 * 
 * @export
 * @interface CustomerPurchaseOrderResponseSummaryAllOf
 */
export interface CustomerPurchaseOrderResponseSummaryAllOf {
    /**
     * 
     * @type {string}
     * @memberof CustomerPurchaseOrderResponseSummaryAllOf
     */
    'order_closing_date'?: string;
    /**
     * 
     * @type {CustomerPurchaseOrderResponseSummaryAllOfReseller}
     * @memberof CustomerPurchaseOrderResponseSummaryAllOf
     */
    'reseller': CustomerPurchaseOrderResponseSummaryAllOfReseller | null;
}
/**
 * 
 * @export
 * @interface CustomerPurchaseOrderResponseSummaryAllOfReseller
 */
export interface CustomerPurchaseOrderResponseSummaryAllOfReseller {
    /**
     * 
     * @type {string}
     * @memberof CustomerPurchaseOrderResponseSummaryAllOfReseller
     */
    'organization_id': string;
    /**
     * 
     * @type {string}
     * @memberof CustomerPurchaseOrderResponseSummaryAllOfReseller
     */
    'organization_name': string;
}
/**
 * 
 * @export
 * @interface Customization
 */
export interface Customization {
    /**
     * 
     * @type {string}
     * @memberof Customization
     */
    'customization_id': string;
    /**
     * 
     * @type {string}
     * @memberof Customization
     */
    'name': string | null;
    /**
     * 
     * @type {CustomizationStatus}
     * @memberof Customization
     */
    'status': CustomizationStatus;
    /**
     * 
     * @type {Configurations}
     * @memberof Customization
     */
    'configurations': Configurations;
}


/**
 * 
 * @export
 * @interface CustomizationRedeemableInventoryItem
 */
export interface CustomizationRedeemableInventoryItem {
    /**
     * 
     * @type {string}
     * @memberof CustomizationRedeemableInventoryItem
     */
    'inventory_product_name': string;
    /**
     * 
     * @type {number}
     * @memberof CustomizationRedeemableInventoryItem
     */
    'inventory_product_id': number;
    /**
     * 
     * @type {Array<CustomizationRedeemableInventoryItemProduct>}
     * @memberof CustomizationRedeemableInventoryItem
     */
    'available_products': Array<CustomizationRedeemableInventoryItemProduct>;
}
/**
 * 
 * @export
 * @interface CustomizationRedeemableInventoryItemProduct
 */
export interface CustomizationRedeemableInventoryItemProduct {
    /**
     * 
     * @type {string}
     * @memberof CustomizationRedeemableInventoryItemProduct
     */
    'product_name': string;
    /**
     * 
     * @type {number}
     * @memberof CustomizationRedeemableInventoryItemProduct
     */
    'product_id': number;
}
/**
 * 
 * @export
 * @interface CustomizationResultSet
 */
export interface CustomizationResultSet {
    /**
     * 
     * @type {number}
     * @memberof CustomizationResultSet
     */
    'count': number;
    /**
     * 
     * @type {number}
     * @memberof CustomizationResultSet
     */
    'total_count': number;
    /**
     * 
     * @type {Array<Customization>}
     * @memberof CustomizationResultSet
     */
    'customizations': Array<Customization>;
}
/**
 * 
 * @export
 * @interface CustomizationResultSetAllOf
 */
export interface CustomizationResultSetAllOf {
    /**
     * 
     * @type {Array<Customization>}
     * @memberof CustomizationResultSetAllOf
     */
    'customizations': Array<Customization>;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum CustomizationStatus {
    Active = 'active',
    Decommissioned = 'decommissioned'
}


/**
 * 
 * @export
 * @interface CustomizationWithRedeemableInventory
 */
export interface CustomizationWithRedeemableInventory {
    /**
     * 
     * @type {string}
     * @memberof CustomizationWithRedeemableInventory
     */
    'customization_id': string;
    /**
     * 
     * @type {string}
     * @memberof CustomizationWithRedeemableInventory
     */
    'name': string | null;
    /**
     * 
     * @type {CustomizationStatus}
     * @memberof CustomizationWithRedeemableInventory
     */
    'status': CustomizationStatus;
    /**
     * 
     * @type {Configurations}
     * @memberof CustomizationWithRedeemableInventory
     */
    'configurations': Configurations;
    /**
     * 
     * @type {Array<CustomizationRedeemableInventoryItem>}
     * @memberof CustomizationWithRedeemableInventory
     */
    'redeemable_inventory': Array<CustomizationRedeemableInventoryItem>;
}


/**
 * 
 * @export
 * @interface CustomizationWithRedeemableInventoryAllOf
 */
export interface CustomizationWithRedeemableInventoryAllOf {
    /**
     * 
     * @type {Array<CustomizationRedeemableInventoryItem>}
     * @memberof CustomizationWithRedeemableInventoryAllOf
     */
    'redeemable_inventory': Array<CustomizationRedeemableInventoryItem>;
}
/**
 * 
 * @export
 * @interface DeliveryTypeResponse
 */
export interface DeliveryTypeResponse {
    /**
     * 
     * @type {number}
     * @memberof DeliveryTypeResponse
     */
    'value': number;
    /**
     * 
     * @type {string}
     * @memberof DeliveryTypeResponse
     */
    'name': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum EmailTemplateId {
    Shipped = 'shipped',
    Delivered = 'delivered',
    DeliveryExceptions = 'delivery_exceptions',
    TrackingUpdate = 'tracking_update'
}


/**
 * Deprecated: To be replaced by \'#/components/schemas/StandardErrorDetail\'
 * @export
 * @interface ErrorDetail
 */
export interface ErrorDetail {
    /**
     * The message explaining the detailed error in text.
     * @type {string}
     * @memberof ErrorDetail
     */
    'message': string;
    /**
     * json path to the field, if the error detail refers to a field
     * @type {string}
     * @memberof ErrorDetail
     */
    'field'?: string;
    /**
     * 
     * @type {string}
     * @memberof ErrorDetail
     * @deprecated
     */
    'description'?: string;
}
/**
 * 
 * @export
 * @interface ErrorDetailAllOf
 */
export interface ErrorDetailAllOf {
    /**
     * 
     * @type {string}
     * @memberof ErrorDetailAllOf
     * @deprecated
     */
    'description'?: string;
}
/**
 * Deprecated: To be replaced by \'#/components/schemas/StandardErrorResult\'
 * @export
 * @interface ErrorDetailResult
 */
export interface ErrorDetailResult {
    /**
     * 
     * @type {string}
     * @memberof ErrorDetailResult
     */
    'code': string;
    /**
     * The error message in text
     * @type {string}
     * @memberof ErrorDetailResult
     */
    'message'?: string;
    /**
     * A list of details of each distinct problem encountered. Omitted when empty
     * @type {Array<StandardErrorDetail>}
     * @memberof ErrorDetailResult
     */
    'errors'?: Array<StandardErrorDetail>;
    /**
     * 
     * @type {string}
     * @memberof ErrorDetailResult
     * @deprecated
     */
    'error'?: string;
    /**
     * 
     * @type {string}
     * @memberof ErrorDetailResult
     * @deprecated
     */
    'errorMessage'?: string;
    /**
     * To be replaced by \'#/components/schemas/StandardErrorDetail\'
     * @type {Array<ErrorDetail>}
     * @memberof ErrorDetailResult
     * @deprecated
     */
    'errorCauses'?: Array<ErrorDetail>;
}
/**
 * 
 * @export
 * @interface ErrorDetailResultAllOf
 */
export interface ErrorDetailResultAllOf {
    /**
     * To be replaced by \'#/components/schemas/StandardErrorDetail\'
     * @type {Array<ErrorDetail>}
     * @memberof ErrorDetailResultAllOf
     * @deprecated
     */
    'errorCauses'?: Array<ErrorDetail>;
}
/**
 * Deprecated: To be replaced by \'#/components/schemas/StandardErrorResult\'
 * @export
 * @interface ErrorResult
 */
export interface ErrorResult {
    /**
     * 
     * @type {string}
     * @memberof ErrorResult
     */
    'code': string;
    /**
     * The error message in text
     * @type {string}
     * @memberof ErrorResult
     */
    'message'?: string;
    /**
     * A list of details of each distinct problem encountered. Omitted when empty
     * @type {Array<StandardErrorDetail>}
     * @memberof ErrorResult
     */
    'errors'?: Array<StandardErrorDetail>;
    /**
     * 
     * @type {string}
     * @memberof ErrorResult
     * @deprecated
     */
    'error'?: string;
    /**
     * 
     * @type {string}
     * @memberof ErrorResult
     * @deprecated
     */
    'errorMessage'?: string;
    /**
     * 
     * @type {Array<object>}
     * @memberof ErrorResult
     * @deprecated
     */
    'errorCauses'?: Array<object>;
}
/**
 * 
 * @export
 * @interface ErrorResultAllOf
 */
export interface ErrorResultAllOf {
    /**
     * 
     * @type {string}
     * @memberof ErrorResultAllOf
     * @deprecated
     */
    'error'?: string;
    /**
     * 
     * @type {string}
     * @memberof ErrorResultAllOf
     * @deprecated
     */
    'errorMessage'?: string;
    /**
     * 
     * @type {Array<object>}
     * @memberof ErrorResultAllOf
     * @deprecated
     */
    'errorCauses'?: Array<object>;
}
/**
 * 
 * @export
 * @interface FPRShipmentRecipientAddressRequest
 */
export interface FPRShipmentRecipientAddressRequest {
    /**
     * 
     * @type {Recipient}
     * @memberof FPRShipmentRecipientAddressRequest
     */
    'recipient'?: Recipient;
    /**
     * 
     * @type {MailingAddress}
     * @memberof FPRShipmentRecipientAddressRequest
     */
    'mailing_address'?: MailingAddress;
    /**
     * 
     * @type {ShipmentDeliveryTypeEnum}
     * @memberof FPRShipmentRecipientAddressRequest
     */
    'delivery_type'?: ShipmentDeliveryTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof FPRShipmentRecipientAddressRequest
     */
    'address_validation_bypass'?: boolean;
}


/**
 * 
 * @export
 * @interface FPRShipmentRequest
 */
export interface FPRShipmentRequest {
    /**
     * Optional ID for the reseller this shipment\'s inventory was purchased through.
     * @type {string}
     * @memberof FPRShipmentRequest
     */
    'reseller_organization_id'?: string;
    /**
     * 
     * @type {ShipmentDeliveryTypeEnum}
     * @memberof FPRShipmentRequest
     */
    'delivery_type': ShipmentDeliveryTypeEnum;
    /**
     * 
     * @type {FPRShipmentRequestRecipient}
     * @memberof FPRShipmentRequest
     */
    'recipient': FPRShipmentRequestRecipient;
    /**
     * 
     * @type {FPRShipmentRequestMailingAddress}
     * @memberof FPRShipmentRequest
     */
    'mailing_address': FPRShipmentRequestMailingAddress;
    /**
     * 
     * @type {Array<FPRShipmentRequestProduct>}
     * @memberof FPRShipmentRequest
     */
    'shipment_items': Array<FPRShipmentRequestProduct>;
    /**
     * 
     * @type {boolean}
     * @memberof FPRShipmentRequest
     */
    'address_validation_bypass'?: boolean;
}


/**
 * 
 * @export
 * @interface FPRShipmentRequestMailingAddress
 */
export interface FPRShipmentRequestMailingAddress {
    /**
     * 
     * @type {string}
     * @memberof FPRShipmentRequestMailingAddress
     */
    'street_line1'?: string;
    /**
     * 
     * @type {string}
     * @memberof FPRShipmentRequestMailingAddress
     */
    'street_line2'?: string;
    /**
     * 
     * @type {string}
     * @memberof FPRShipmentRequestMailingAddress
     * @deprecated
     */
    'street_line3'?: string;
    /**
     * 
     * @type {string}
     * @memberof FPRShipmentRequestMailingAddress
     */
    'city'?: string;
    /**
     * 
     * @type {string}
     * @memberof FPRShipmentRequestMailingAddress
     */
    'region'?: string;
    /**
     * 
     * @type {string}
     * @memberof FPRShipmentRequestMailingAddress
     */
    'postal_code'?: string;
    /**
     * 
     * @type {string}
     * @memberof FPRShipmentRequestMailingAddress
     */
    'country_code_2'?: string;
}
/**
 * 
 * @export
 * @interface FPRShipmentRequestProduct
 */
export interface FPRShipmentRequestProduct {
    /**
     * See more details at https://console.yubico.com/help/api-req.html#product-id-and-inventory-product-id
     * @type {number}
     * @memberof FPRShipmentRequestProduct
     */
    'product_id': number;
    /**
     * See more details at https://console.yubico.com/help/api-req.html#product-id-and-inventory-product-id
     * @type {number}
     * @memberof FPRShipmentRequestProduct
     */
    'inventory_product_id': number;
    /**
     * 
     * @type {number}
     * @memberof FPRShipmentRequestProduct
     */
    'product_quantity': number;
    /**
     * Configuration ID for the custom configuration to be applied to a Yubikey
     * @type {string}
     * @memberof FPRShipmentRequestProduct
     */
    'customization_id': string;
    /**
     * 
     * @type {Array<FPRShipmentRequestProductCustomization>}
     * @memberof FPRShipmentRequestProduct
     */
    'product_customizations': Array<FPRShipmentRequestProductCustomization>;
}
/**
 * 
 * @export
 * @interface FPRShipmentRequestProductCustomization
 */
export interface FPRShipmentRequestProductCustomization {
    /**
     * 
     * @type {string}
     * @memberof FPRShipmentRequestProductCustomization
     */
    'fido_pin_request': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof FPRShipmentRequestProductCustomization
     */
    'fido_credential_requests': Array<string>;
}
/**
 * 
 * @export
 * @interface FPRShipmentRequestRecipient
 */
export interface FPRShipmentRequestRecipient {
    /**
     * 
     * @type {string}
     * @memberof FPRShipmentRequestRecipient
     */
    'recipient_company'?: string;
    /**
     * 
     * @type {string}
     * @memberof FPRShipmentRequestRecipient
     */
    'recipient_email'?: string;
    /**
     * 
     * @type {string}
     * @memberof FPRShipmentRequestRecipient
     */
    'recipient_firstname'?: string;
    /**
     * 
     * @type {string}
     * @memberof FPRShipmentRequestRecipient
     */
    'recipient_lastname'?: string;
    /**
     * 
     * @type {string}
     * @memberof FPRShipmentRequestRecipient
     */
    'recipient_telephone'?: string;
}
/**
 * 
 * @export
 * @interface FPRShipmentResponse
 */
export interface FPRShipmentResponse {
    /**
     * 
     * @type {string}
     * @memberof FPRShipmentResponse
     */
    'shipment_id': string;
    /**
     * 
     * @type {string}
     * @memberof FPRShipmentResponse
     */
    'shipment_type': string;
    /**
     * 
     * @type {ShipmentDeliveryTypeEnum}
     * @memberof FPRShipmentResponse
     */
    'delivery_type': ShipmentDeliveryTypeEnum;
    /**
     * 
     * @type {CustomerPurchaseOrderResponseSummaryAllOfReseller}
     * @memberof FPRShipmentResponse
     */
    'reseller': CustomerPurchaseOrderResponseSummaryAllOfReseller | null;
    /**
     * 
     * @type {Recipient}
     * @memberof FPRShipmentResponse
     */
    'recipient': Recipient;
    /**
     * 
     * @type {MailingAddress}
     * @memberof FPRShipmentResponse
     */
    'mailing_address': MailingAddress;
    /**
     * 
     * @type {Tracking}
     * @memberof FPRShipmentResponse
     */
    'tracking'?: Tracking;
    /**
     * 
     * @type {ShipmentRequestor}
     * @memberof FPRShipmentResponse
     */
    'shipment_requestor': ShipmentRequestor;
    /**
     * 
     * @type {ShipmentState}
     * @memberof FPRShipmentResponse
     */
    'shipment_state': ShipmentState;
    /**
     * 
     * @type {Array<FPRShipmentResponseProduct>}
     * @memberof FPRShipmentResponse
     */
    'shipment_items': Array<FPRShipmentResponseProduct>;
    /**
     * 
     * @type {string}
     * @memberof FPRShipmentResponse
     */
    'shipment_request_date': string;
    /**
     * 
     * @type {string}
     * @memberof FPRShipmentResponse
     */
    'shipment_updated_date': string;
    /**
     * 
     * @type {Array<ShipmentHistoryMessage>}
     * @memberof FPRShipmentResponse
     */
    'shipment_messages': Array<ShipmentHistoryMessage>;
    /**
     * 
     * @type {boolean}
     * @memberof FPRShipmentResponse
     */
    'address_validation_bypass': boolean;
}


/**
 * 
 * @export
 * @interface FPRShipmentResponseProduct
 */
export interface FPRShipmentResponseProduct {
    /**
     * Configuration ID for the custom configuration to be applied to a Yubikey
     * @type {string}
     * @memberof FPRShipmentResponseProduct
     */
    'customization_id': string;
    /**
     * 
     * @type {number}
     * @memberof FPRShipmentResponseProduct
     */
    'product_id': number;
    /**
     * 
     * @type {number}
     * @memberof FPRShipmentResponseProduct
     */
    'inventory_product_id': number;
    /**
     * 
     * @type {number}
     * @memberof FPRShipmentResponseProduct
     */
    'product_quantity': number;
    /**
     * 
     * @type {Array<FPRShipmentResponseProductData>}
     * @memberof FPRShipmentResponseProduct
     */
    'product_data'?: Array<FPRShipmentResponseProductData>;
}
/**
 * 
 * @export
 * @interface FPRShipmentResponseProductData
 */
export interface FPRShipmentResponseProductData {
    /**
     * 
     * @type {string}
     * @memberof FPRShipmentResponseProductData
     */
    'serial_number': string | null;
    /**
     * 
     * @type {string}
     * @memberof FPRShipmentResponseProductData
     */
    'firmware_version': string | null;
    /**
     * 
     * @type {string}
     * @memberof FPRShipmentResponseProductData
     */
    'fido_pin_response': string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof FPRShipmentResponseProductData
     */
    'fido_credential_responses': Array<string>;
}
/**
 * 
 * @export
 * @interface FPRShipmentResponseProductDataAllOf
 */
export interface FPRShipmentResponseProductDataAllOf {
    /**
     * 
     * @type {string}
     * @memberof FPRShipmentResponseProductDataAllOf
     */
    'fido_pin_response': string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof FPRShipmentResponseProductDataAllOf
     */
    'fido_credential_responses': Array<string>;
}
/**
 * 
 * @export
 * @interface InventoryAllocationCollectionResponse
 */
export interface InventoryAllocationCollectionResponse {
    /**
     * 
     * @type {Array<InventoryAllocationResponse>}
     * @memberof InventoryAllocationCollectionResponse
     */
    'allocations': Array<InventoryAllocationResponse>;
}
/**
 * 
 * @export
 * @interface InventoryAllocationResponse
 */
export interface InventoryAllocationResponse {
    /**
     * 
     * @type {number}
     * @memberof InventoryAllocationResponse
     */
    'product_id': number;
    /**
     * 
     * @type {string}
     * @memberof InventoryAllocationResponse
     */
    'product_name': string;
    /**
     * 
     * @type {string}
     * @memberof InventoryAllocationResponse
     */
    'customization_id': string | null;
    /**
     * 
     * @type {number}
     * @memberof InventoryAllocationResponse
     */
    'remaining_allocated_inventory': number;
}
/**
 * 1 = YubiKey Shipment (outright purchase) 2 = YubiKey Tier SKU Shipment (purchase of virtual keys) 3 = Subscription - Initial Shipment (Subscription) 4 = Subscription - Buffer Stock Shipment (Subscription) 5 = Subscription - Replacement YubiKey Shipment (Subscription) 
 * @export
 * @enum {string}
 */

export enum InventoryTypeEnum {
    YubiKeyShipment = 1,
    YubiKeyTierSKUShipment = 2,
    SubscriptionInitialShipment = 3,
    SubscriptionBufferStockShipment = 4,
    SubscriptionReplacementShipment = 5
}


/**
 * @type ListAllUsersInOrganizationSearchParameter
 * @export
 */
export type ListAllUsersInOrganizationSearchParameter = Array<string> | string;

/**
 * 
 * @export
 * @interface MailingAddress
 */
export interface MailingAddress {
    /**
     * 
     * @type {string}
     * @memberof MailingAddress
     */
    'street_line1'?: string;
    /**
     * 
     * @type {string}
     * @memberof MailingAddress
     */
    'street_line2'?: string;
    /**
     * 
     * @type {string}
     * @memberof MailingAddress
     * @deprecated
     */
    'street_line3'?: string;
    /**
     * 
     * @type {string}
     * @memberof MailingAddress
     */
    'city'?: string;
    /**
     * 
     * @type {string}
     * @memberof MailingAddress
     */
    'region'?: string;
    /**
     * 
     * @type {string}
     * @memberof MailingAddress
     */
    'postal_code'?: string;
    /**
     * 
     * @type {string}
     * @memberof MailingAddress
     */
    'country_code_2'?: string;
}
/**
 * 
 * @export
 * @interface OrgInfo
 */
export interface OrgInfo {
    /**
     * 
     * @type {string}
     * @memberof OrgInfo
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof OrgInfo
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof OrgInfo
     */
    'slug'?: string;
    /**
     * The use of this property is not recommended, as it is an experimental field that is likely to change.
     * @type {boolean}
     * @memberof OrgInfo
     */
    'sso_enabled'?: boolean;
    /**
     * The use of this property is not recommended, as it is an experimental field that is likely to change.
     * @type {string}
     * @memberof OrgInfo
     */
    'sp_login_url'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof OrgInfo
     */
    'roles': Array<string>;
}
/**
 * 
 * @export
 * @interface Organization
 */
export interface Organization {
    /**
     * 
     * @type {string}
     * @memberof Organization
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof Organization
     */
    'external_id': string;
    /**
     * 
     * @type {string}
     * @memberof Organization
     */
    'slug': string;
    /**
     * 
     * @type {string}
     * @memberof Organization
     */
    'name': string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof Organization
     */
    'settings': { [key: string]: string; };
    /**
     * This property list all roles that the organization has in at least one purchaseorder. The goal is to indicate which type of roles the organization\'s users can have. 
     * @type {Array<PurchaseOrderRoleEnum>}
     * @memberof Organization
     */
    'purchaseorder_roles': Array<PurchaseOrderRoleEnum>;
}
/**
 * 
 * @export
 * @interface OrganizationIdAndName
 */
export interface OrganizationIdAndName {
    /**
     * 
     * @type {string}
     * @memberof OrganizationIdAndName
     */
    'organization_id': string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationIdAndName
     */
    'organization_name': string;
}
/**
 * 
 * @export
 * @interface OrganizationProductChannelPartnerInventory
 */
export interface OrganizationProductChannelPartnerInventory {
    /**
     * 
     * @type {string}
     * @memberof OrganizationProductChannelPartnerInventory
     * @deprecated
     */
    'organization_product_inventory_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationProductChannelPartnerInventory
     * @deprecated
     */
    'organization_id'?: string;
    /**
     * 
     * @type {number}
     * @memberof OrganizationProductChannelPartnerInventory
     */
    'product_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof OrganizationProductChannelPartnerInventory
     */
    'product_name'?: string;
    /**
     * The remaining quantity the organization has of this product. Some of this quantity may not be available to ship immediately (because of allocation limits), and some of it may only be available with a specific customization. Refer to amounts_per_customization for a complete view of the remaining inventory, but note that if there is more than one customization available for this product, the amounts therein are independent from each other and should not be summed. 
     * @type {number}
     * @memberof OrganizationProductChannelPartnerInventory
     */
    'organization_product_quantity'?: number;
    /**
     * 
     * @type {InventoryTypeEnum}
     * @memberof OrganizationProductChannelPartnerInventory
     */
    'inventory_type'?: InventoryTypeEnum;
    /**
     * Deprecated: refer to inventory_type instead. 
     * @type {boolean}
     * @memberof OrganizationProductChannelPartnerInventory
     * @deprecated
     */
    'is_subscription_product'?: boolean;
    /**
     * Deprecated: refer to inventory_type instead. 
     * @type {boolean}
     * @memberof OrganizationProductChannelPartnerInventory
     * @deprecated
     */
    'is_virtual_product'?: boolean;
    /**
     * The products that can be ordered from this product\'s inventory, as a list of product ID\'s. If this product is a YubiKey Shipment product, this array will contain exactly one element, being this product\'s own product ID. 
     * @type {Array<number>}
     * @memberof OrganizationProductChannelPartnerInventory
     */
    'product_mapping'?: Array<number>;
    /**
     * The total amount of inventory purchased of this product. If there is more than one customization available for this product, refer to amounts_per_customization for a complete view of the inventory. 
     * @type {number}
     * @memberof OrganizationProductChannelPartnerInventory
     */
    'amount_total'?: number;
    /**
     * The customization ID\'s available for this product. Empty if only standard keys are available. 
     * @type {Array<string>}
     * @memberof OrganizationProductChannelPartnerInventory
     */
    'customizations'?: Array<string>;
    /**
     * 
     * @type {Array<AmountsPerCustomization>}
     * @memberof OrganizationProductChannelPartnerInventory
     */
    'amounts_per_customization'?: Array<AmountsPerCustomization>;
}


/**
 * 
 * @export
 * @interface OrganizationProductChannelPartnerInventorySet
 */
export interface OrganizationProductChannelPartnerInventorySet {
    /**
     * 
     * @type {number}
     * @memberof OrganizationProductChannelPartnerInventorySet
     */
    'count'?: number;
    /**
     * 
     * @type {number}
     * @memberof OrganizationProductChannelPartnerInventorySet
     */
    'total_count'?: number;
    /**
     * 
     * @type {Array<OrganizationProductChannelPartnerInventory>}
     * @memberof OrganizationProductChannelPartnerInventorySet
     */
    'organization_product_inventory'?: Array<OrganizationProductChannelPartnerInventory>;
}
/**
 * 
 * @export
 * @interface OrganizationProductInventory
 */
export interface OrganizationProductInventory {
    /**
     * 
     * @type {string}
     * @memberof OrganizationProductInventory
     * @deprecated
     */
    'organization_product_inventory_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationProductInventory
     * @deprecated
     */
    'organization_id'?: string;
    /**
     * 
     * @type {number}
     * @memberof OrganizationProductInventory
     */
    'product_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof OrganizationProductInventory
     */
    'product_name'?: string;
    /**
     * The remaining quantity the organization has of this product. Some of this quantity may not be available to ship immediately (because of allocation limits), and some of it may only be available with a specific customization. Refer to amounts_per_customization for a complete view of the remaining inventory, but note that if there is more than one customization available for this product, the amounts therein are independent from each other and should not be summed. 
     * @type {number}
     * @memberof OrganizationProductInventory
     */
    'organization_product_quantity'?: number;
    /**
     * 
     * @type {InventoryTypeEnum}
     * @memberof OrganizationProductInventory
     */
    'inventory_type'?: InventoryTypeEnum;
    /**
     * Deprecated: refer to inventory_type instead. 
     * @type {boolean}
     * @memberof OrganizationProductInventory
     * @deprecated
     */
    'is_subscription_product'?: boolean;
    /**
     * Deprecated: refer to inventory_type instead. 
     * @type {boolean}
     * @memberof OrganizationProductInventory
     * @deprecated
     */
    'is_virtual_product'?: boolean;
    /**
     * The products that can be ordered from this product\'s inventory, as a list of product ID\'s. If this product is a YubiKey Shipment product, this array will contain exactly one element, being this product\'s own product ID. 
     * @type {Array<number>}
     * @memberof OrganizationProductInventory
     */
    'product_mapping'?: Array<number>;
    /**
     * The total amount of inventory purchased of this product. If there is more than one customization available for this product, refer to amounts_per_customization for a complete view of the inventory. 
     * @type {number}
     * @memberof OrganizationProductInventory
     */
    'amount_total'?: number;
    /**
     * The customization ID\'s available for this product. Empty if only standard keys are available. 
     * @type {Array<string>}
     * @memberof OrganizationProductInventory
     */
    'customizations'?: Array<string>;
    /**
     * 
     * @type {Array<AmountsPerCustomization>}
     * @memberof OrganizationProductInventory
     */
    'amounts_per_customization'?: Array<AmountsPerCustomization>;
    /**
     * This property returns all non-consumed inventory amount of `product_id` regardless of any inventory allocation limits. Deprecated: use organization_product_quantity instead. 
     * @type {number}
     * @memberof OrganizationProductInventory
     * @deprecated
     */
    'remaining_purchased_quantity'?: number;
}


/**
 * 
 * @export
 * @interface OrganizationProductInventoryAllOf
 */
export interface OrganizationProductInventoryAllOf {
    /**
     * This property returns all non-consumed inventory amount of `product_id` regardless of any inventory allocation limits. Deprecated: use organization_product_quantity instead. 
     * @type {number}
     * @memberof OrganizationProductInventoryAllOf
     * @deprecated
     */
    'remaining_purchased_quantity'?: number;
}
/**
 * 
 * @export
 * @interface OrganizationProductInventorySet
 */
export interface OrganizationProductInventorySet {
    /**
     * 
     * @type {number}
     * @memberof OrganizationProductInventorySet
     */
    'count'?: number;
    /**
     * 
     * @type {number}
     * @memberof OrganizationProductInventorySet
     */
    'total_count'?: number;
    /**
     * 
     * @type {Array<OrganizationProductInventory>}
     * @memberof OrganizationProductInventorySet
     */
    'organization_product_inventory'?: Array<OrganizationProductInventory>;
}
/**
 * 
 * @export
 * @interface OrganizationUser
 */
export interface OrganizationUser {
    /**
     * 
     * @type {string}
     * @memberof OrganizationUser
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationUser
     */
    'email': string;
    /**
     * This property is soon to be deprecated. Please, use the `roles` property instead.
     * @type {string}
     * @memberof OrganizationUser
     * @deprecated
     */
    'role'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationUser
     */
    'last_login': string | null;
    /**
     * 
     * @type {string}
     * @memberof OrganizationUser
     */
    'state': string;
    /**
     * The use of this property is not recommended, as it is an experimental field that is likely to change. True when the user has one or more mfa registered. 
     * @type {boolean}
     * @memberof OrganizationUser
     */
    'mfa_registered': boolean;
    /**
     * The use of this property is not recommended, as it is an experimental field that is likely to change. True when the user has password registered. 
     * @type {boolean}
     * @memberof OrganizationUser
     */
    'password_registered': boolean;
    /**
     * The use of this property is not recommended, as it is an experimental field that is likely to change. True when the user has migrated to passwordless authentication. 
     * @type {boolean}
     * @memberof OrganizationUser
     */
    'passwordless_migrated': boolean;
    /**
     * The use of this property is not recommended, as it is an experimental field that is likely to change. The number of passkeys a user has registered. 
     * @type {number}
     * @memberof OrganizationUser
     */
    'passkey_count': number;
    /**
     * 
     * @type {PasskeyComplianceStatus}
     * @memberof OrganizationUser
     */
    'compliance_status': PasskeyComplianceStatus;
    /**
     * This property returns multiple roles of a user and is prefered over the old `role` property.
     * @type {Array<string>}
     * @memberof OrganizationUser
     */
    'roles': Array<string>;
}


/**
 * 
 * @export
 * @interface OrganizationUsersResultSet
 */
export interface OrganizationUsersResultSet {
    /**
     * 
     * @type {number}
     * @memberof OrganizationUsersResultSet
     */
    'count': number;
    /**
     * 
     * @type {number}
     * @memberof OrganizationUsersResultSet
     */
    'total_count': number;
    /**
     * 
     * @type {Array<OrganizationUser>}
     * @memberof OrganizationUsersResultSet
     */
    'users': Array<OrganizationUser>;
}
/**
 * 
 * @export
 * @interface PaginationFields
 */
export interface PaginationFields {
    /**
     * 
     * @type {number}
     * @memberof PaginationFields
     */
    'count': number;
    /**
     * 
     * @type {number}
     * @memberof PaginationFields
     */
    'total_count': number;
}
/**
 * Passkey security compliance status. Default=NotApplicable
 * @export
 * @enum {string}
 */

export enum PasskeyComplianceStatus {
    NotApplicable = 1,
    Compliant = 2,
    Noncompliant = 3
}


/**
 * 
 * @export
 * @interface Product
 */
export interface Product {
    /**
     * 
     * @type {number}
     * @memberof Product
     */
    'product_id': number;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    'product_name': string;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    'product_code': string;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    'product_sku': string;
    /**
     * 
     * @type {number}
     * @memberof Product
     */
    'product_tier': number;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    'product_image': string;
    /**
     * 
     * @type {boolean}
     * @memberof Product
     */
    'product_is_active': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Product
     */
    'product_is_available': boolean;
    /**
     * 
     * @type {string}
     * @memberof Product
     * @deprecated
     */
    'product_availability_message': string;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    'ro_stock_number': string;
    /**
     * 
     * @type {InventoryTypeEnum}
     * @memberof Product
     */
    'inventory_type': InventoryTypeEnum;
    /**
     * 
     * @type {SubscriptionTypeEnum}
     * @memberof Product
     */
    'subscription_type': SubscriptionTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof Product
     */
    'is_subscription_product': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Product
     */
    'is_virtual_product': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Product
     */
    'is_default': boolean;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    'customization_id': string | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof Product
     */
    'product_mapping': Array<number>;
    /**
     * 
     * @type {boolean}
     * @memberof Product
     */
    'is_customizable': boolean;
    /**
     * 
     * @type {number}
     * @memberof Product
     */
    'netsuite_id_standard'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof Product
     */
    'netsuite_id_custom'?: number | null;
}


/**
 * 
 * @export
 * @interface ProductRefundResponse
 */
export interface ProductRefundResponse {
    /**
     * 
     * @type {string}
     * @memberof ProductRefundResponse
     */
    'product_refund_id': string;
    /**
     * 
     * @type {string}
     * @memberof ProductRefundResponse
     */
    'inventory_allocation_id': string;
    /**
     * 
     * @type {number}
     * @memberof ProductRefundResponse
     */
    'inventory_product_id': number;
    /**
     * 
     * @type {number}
     * @memberof ProductRefundResponse
     */
    'product_id': number;
    /**
     * 
     * @type {number}
     * @memberof ProductRefundResponse
     */
    'refund_quantity': number;
    /**
     * 
     * @type {number}
     * @memberof ProductRefundResponse
     */
    'product_cost': number;
    /**
     * 
     * @type {number}
     * @memberof ProductRefundResponse
     */
    'product_tax': number;
    /**
     * 
     * @type {number}
     * @memberof ProductRefundResponse
     */
    'product_vat': number;
    /**
     * 
     * @type {string}
     * @memberof ProductRefundResponse
     */
    'purchaseorder_id': string;
    /**
     * 
     * @type {string}
     * @memberof ProductRefundResponse
     */
    'purchaseorder_number': string;
    /**
     * 
     * @type {string}
     * @memberof ProductRefundResponse
     */
    'refund_date': string;
    /**
     * 
     * @type {string}
     * @memberof ProductRefundResponse
     */
    'customization_id': string | null;
}
/**
 * 
 * @export
 * @interface ProductResultSet
 */
export interface ProductResultSet {
    /**
     * 
     * @type {number}
     * @memberof ProductResultSet
     */
    'count': number;
    /**
     * 
     * @type {number}
     * @memberof ProductResultSet
     */
    'total_count': number;
    /**
     * 
     * @type {Array<Product>}
     * @memberof ProductResultSet
     */
    'products': Array<Product>;
}
/**
 * 
 * @export
 * @interface ProductResultSetAllOf
 */
export interface ProductResultSetAllOf {
    /**
     * 
     * @type {Array<Product>}
     * @memberof ProductResultSetAllOf
     */
    'products': Array<Product>;
}
/**
 * 
 * @export
 * @interface PurchaseOrderProductResponse
 */
export interface PurchaseOrderProductResponse {
    /**
     * 
     * @type {number}
     * @memberof PurchaseOrderProductResponse
     */
    'product_id': number;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderProductResponse
     */
    'purchaseorder_product_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderProductResponse
     */
    'purchaseorder_id'?: string;
    /**
     * 
     * @type {number}
     * @memberof PurchaseOrderProductResponse
     */
    'purchaseorder_product_quantity': number;
    /**
     * 
     * @type {number}
     * @memberof PurchaseOrderProductResponse
     */
    'purchaseorder_product_quantity_remaining'?: number;
    /**
     * 
     * @type {number}
     * @memberof PurchaseOrderProductResponse
     */
    'purchaseorder_product_cost': number;
    /**
     * 
     * @type {Array<string>}
     * @memberof PurchaseOrderProductResponse
     */
    'customizations': Array<string>;
}
/**
 * 
 * @export
 * @interface PurchaseOrderResponse
 */
export interface PurchaseOrderResponse {
    /**
     * 
     * @type {number}
     * @memberof PurchaseOrderResponse
     */
    'channelpartner_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderResponse
     */
    'channelpartner_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderResponse
     */
    'closing_city'?: string;
    /**
     * 
     * @type {number}
     * @memberof PurchaseOrderResponse
     */
    'closing_country_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderResponse
     */
    'closing_postal_code'?: string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderResponse
     */
    'closing_region'?: string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderResponse
     */
    'closing_street_line1'?: string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderResponse
     */
    'closing_street_line2'?: string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderResponse
     * @deprecated
     */
    'closing_street_line3'?: string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderResponse
     */
    'closing_country_code_2'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PurchaseOrderResponse
     */
    'is_closed'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PurchaseOrderResponse
     */
    'is_post_pay'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PurchaseOrderResponse
     */
    'is_tax_exempt'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PurchaseOrderResponse
     */
    'is_vat_valid'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderResponse
     */
    'vat_number'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PurchaseOrderResponse
     */
    'allow_automated_shipments': boolean;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderResponse
     */
    'key_contact'?: string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderResponse
     */
    'key_contact_email'?: string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderResponse
     */
    'key_contact_phone_number'?: string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderResponse
     */
    'order_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderResponse
     * @deprecated
     */
    'organization_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderResponse
     */
    'organization_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderResponse
     */
    'organizations_shippingaccount_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderResponse
     */
    'organizations_taxaccount_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderResponse
     */
    'organizations_vataccount_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderResponse
     */
    'purchaseorder_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderResponse
     */
    'purchaseorder_number'?: string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderResponse
     */
    'yubicoorder_number'?: string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderResponse
     */
    'yubicoinvoice_number'?: string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderResponse
     */
    'purchaseorder_state_message'?: string;
    /**
     * 
     * @type {number}
     * @memberof PurchaseOrderResponse
     */
    'purchaseorder_state_id'?: number;
    /**
     * 
     * @type {number}
     * @memberof PurchaseOrderResponse
     */
    'shipping_credit_purchased'?: number;
    /**
     * 
     * @type {number}
     * @memberof PurchaseOrderResponse
     */
    'shipping_credit_remaining'?: number;
    /**
     * 
     * @type {number}
     * @memberof PurchaseOrderResponse
     */
    'tax_credit_purchased'?: number;
    /**
     * 
     * @type {number}
     * @memberof PurchaseOrderResponse
     */
    'tax_credit_remaining'?: number;
    /**
     * 
     * @type {number}
     * @memberof PurchaseOrderResponse
     */
    'total_keys_purchased'?: number;
    /**
     * 
     * @type {number}
     * @memberof PurchaseOrderResponse
     */
    'total_keys_remaining'?: number;
    /**
     * 
     * @type {number}
     * @memberof PurchaseOrderResponse
     */
    'vat_credit_purchased'?: number;
    /**
     * 
     * @type {number}
     * @memberof PurchaseOrderResponse
     */
    'vat_credit_remaining'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PurchaseOrderResponse
     */
    'is_override_shipping'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PurchaseOrderResponse
     */
    'override_shipping_charge'?: number;
    /**
     * 
     * @type {number}
     * @memberof PurchaseOrderResponse
     */
    'override_shipping_key_limit'?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum PurchaseOrderRoleEnum {
    Customer = 'customer',
    Reseller = 'reseller',
    Distributor = 'distributor'
}


/**
 * 
 * @export
 * @interface Recipient
 */
export interface Recipient {
    /**
     * 
     * @type {string}
     * @memberof Recipient
     */
    'recipient_company'?: string;
    /**
     * 
     * @type {string}
     * @memberof Recipient
     */
    'recipient_email'?: string;
    /**
     * 
     * @type {string}
     * @memberof Recipient
     */
    'recipient_firstname'?: string;
    /**
     * 
     * @type {string}
     * @memberof Recipient
     */
    'recipient_lastname'?: string;
    /**
     * 
     * @type {string}
     * @memberof Recipient
     */
    'recipient_telephone'?: string;
}
/**
 * 
 * @export
 * @interface RefundResponse
 */
export interface RefundResponse {
    /**
     * 
     * @type {string}
     * @memberof RefundResponse
     */
    'refund_id': string;
    /**
     * 
     * @type {string}
     * @memberof RefundResponse
     */
    'shipment_id': string;
    /**
     * 
     * @type {number}
     * @memberof RefundResponse
     */
    'channelpartner_id': number;
    /**
     * 
     * @type {string}
     * @memberof RefundResponse
     */
    'purchaseorder_id': string;
    /**
     * 
     * @type {string}
     * @memberof RefundResponse
     */
    'purchaseorder_number': string;
    /**
     * 
     * @type {number}
     * @memberof RefundResponse
     */
    'inventory_product_id': number;
    /**
     * 
     * @type {number}
     * @memberof RefundResponse
     */
    'refund_quantity': number;
    /**
     * 
     * @type {number}
     * @memberof RefundResponse
     */
    'product_id': number;
    /**
     * 
     * @type {string}
     * @memberof RefundResponse
     */
    'refund_date': string;
    /**
     * 
     * @type {number}
     * @memberof RefundResponse
     */
    'total_refund_amount': number;
    /**
     * 
     * @type {string}
     * @memberof RefundResponse
     */
    'refund_type': string;
}
/**
 * 
 * @export
 * @interface RefundResultSet
 */
export interface RefundResultSet {
    /**
     * 
     * @type {number}
     * @memberof RefundResultSet
     */
    'count': number;
    /**
     * 
     * @type {number}
     * @memberof RefundResultSet
     */
    'total_count': number;
    /**
     * 
     * @type {Array<RefundResponse>}
     * @memberof RefundResultSet
     */
    'refunds': Array<RefundResponse>;
}
/**
 * 
 * @export
 * @interface RefundResultSetAllOf
 */
export interface RefundResultSetAllOf {
    /**
     * 
     * @type {Array<RefundResponse>}
     * @memberof RefundResultSetAllOf
     */
    'refunds': Array<RefundResponse>;
}
/**
 * 
 * @export
 * @interface ResetAction
 */
export interface ResetAction {
    /**
     * 
     * @type {string}
     * @memberof ResetAction
     */
    'action': string;
}
/**
 * 
 * @export
 * @interface RoleOrRoles
 */
export interface RoleOrRoles {
    /**
     * 
     * @type {string}
     * @memberof RoleOrRoles
     */
    'role'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof RoleOrRoles
     */
    'roles'?: Array<string>;
}
/**
 * 
 * @export
 * @interface Roles
 */
export interface Roles {
    /**
     * 
     * @type {Array<string>}
     * @memberof Roles
     */
    'roles'?: Array<string>;
}
/**
 * 
 * @export
 * @interface SearchDescription
 */
export interface SearchDescription {
    /**
     * 
     * @type {Array<string>}
     * @memberof SearchDescription
     */
    'basic': Array<string>;
    /**
     * 
     * @type {Array<SearchDescriptionAdvanced>}
     * @memberof SearchDescription
     */
    'advanced': Array<SearchDescriptionAdvanced>;
}
/**
 * 
 * @export
 * @interface SearchDescriptionAdvanced
 */
export interface SearchDescriptionAdvanced {
    /**
     * 
     * @type {string}
     * @memberof SearchDescriptionAdvanced
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof SearchDescriptionAdvanced
     */
    'type': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof SearchDescriptionAdvanced
     */
    'operations': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof SearchDescriptionAdvanced
     */
    'select_values'?: Array<string>;
}
/**
 * 
 * @export
 * @interface ShipmentAddressBulkOverrideResponse
 */
export interface ShipmentAddressBulkOverrideResponse {
    /**
     * 
     * @type {string}
     * @memberof ShipmentAddressBulkOverrideResponse
     */
    'message': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ShipmentAddressBulkOverrideResponse
     */
    'failed_shipments': Array<string>;
}
/**
 * 
 * @export
 * @interface ShipmentBulkDeleteResponse
 */
export interface ShipmentBulkDeleteResponse {
    /**
     * 
     * @type {string}
     * @memberof ShipmentBulkDeleteResponse
     */
    'message'?: string;
    /**
     * 
     * @type {Array<ShipmentBulkDeleteResponseFailedShipmentsInner>}
     * @memberof ShipmentBulkDeleteResponse
     */
    'failed_shipments'?: Array<ShipmentBulkDeleteResponseFailedShipmentsInner>;
}
/**
 * 
 * @export
 * @interface ShipmentBulkDeleteResponseFailedShipmentsInner
 */
export interface ShipmentBulkDeleteResponseFailedShipmentsInner {
    /**
     * 
     * @type {string}
     * @memberof ShipmentBulkDeleteResponseFailedShipmentsInner
     */
    'shipment_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentBulkDeleteResponseFailedShipmentsInner
     */
    'fault'?: string;
}
/**
 * Type of delivery service requested, 1 for normal (standard) shipping or 2 for expedited (rush) shipping. Default=1.
 * @export
 * @enum {string}
 */

export enum ShipmentDeliveryTypeEnum {
    Standard = 1,
    Expedited = 2
}


/**
 * 
 * @export
 * @interface ShipmentExactLimitedResponse
 */
export interface ShipmentExactLimitedResponse {
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactLimitedResponse
     */
    'shipment_id'?: string;
    /**
     * 
     * @type {number}
     * @memberof ShipmentExactLimitedResponse
     */
    'channelpartner_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactLimitedResponse
     */
    'channelpartner_name'?: string;
    /**
     * 
     * @type {Array<ShipmentMessage>}
     * @memberof ShipmentExactLimitedResponse
     */
    'shipment_messages'?: Array<ShipmentMessage>;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactLimitedResponse
     */
    'user_email'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactLimitedResponse
     */
    'user_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactLimitedResponse
     */
    'country_code_2'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ShipmentExactLimitedResponse
     */
    'is_delivered'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ShipmentExactLimitedResponse
     */
    'is_sent_to_fulfillment'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ShipmentExactLimitedResponse
     */
    'is_shipped'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ShipmentExactLimitedResponse
     */
    'is_post_pay'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ShipmentExactLimitedResponse
     */
    'is_tax_exempt'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ShipmentExactLimitedResponse
     */
    'address_validation_bypass'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactLimitedResponse
     * @deprecated
     */
    'organization_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactLimitedResponse
     */
    'recipient'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactLimitedResponse
     */
    'recipient_email'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactLimitedResponse
     */
    'recipient_firstname'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactLimitedResponse
     */
    'recipient_lastname'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactLimitedResponse
     */
    'recipient_telephone'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactLimitedResponse
     */
    'street_line1'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactLimitedResponse
     */
    'street_line2'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactLimitedResponse
     * @deprecated
     */
    'street_line3'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactLimitedResponse
     */
    'city'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactLimitedResponse
     */
    'region'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactLimitedResponse
     */
    'postal_code'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactLimitedResponse
     * @deprecated
     */
    'suggest_street_line1'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactLimitedResponse
     * @deprecated
     */
    'suggest_street_line2'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactLimitedResponse
     * @deprecated
     */
    'suggest_street_line3'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactLimitedResponse
     * @deprecated
     */
    'suggest_city'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactLimitedResponse
     * @deprecated
     */
    'suggest_region'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactLimitedResponse
     * @deprecated
     */
    'suggest_postal_code'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactLimitedResponse
     */
    'tracking_link'?: string;
    /**
     * 
     * @type {ShipmentDeliveryTypeEnum}
     * @memberof ShipmentExactLimitedResponse
     */
    'delivery_type'?: ShipmentDeliveryTypeEnum;
    /**
     * 
     * @type {CarrierIdentifierEnum}
     * @memberof ShipmentExactLimitedResponse
     */
    'carrier'?: CarrierIdentifierEnum;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactLimitedResponse
     */
    'tracking_number'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactLimitedResponse
     */
    'shipment_request_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactLimitedResponse
     */
    'shipment_updated_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactLimitedResponse
     */
    'shipped_date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactLimitedResponse
     */
    'delivered_date'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ShipmentExactLimitedResponse
     */
    'shipment_state_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactLimitedResponse
     */
    'shipment_state_message'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactLimitedResponse
     */
    'shipment_customer_message'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactLimitedResponse
     */
    'shipment_summary_description'?: string;
    /**
     * 
     * @type {number}
     * @memberof ShipmentExactLimitedResponse
     */
    'shipment_product_cost'?: number;
    /**
     * 
     * @type {number}
     * @memberof ShipmentExactLimitedResponse
     */
    'shipment_product_taxes'?: number;
    /**
     * 
     * @type {number}
     * @memberof ShipmentExactLimitedResponse
     */
    'shipment_product_vat'?: number;
    /**
     * 
     * @type {number}
     * @memberof ShipmentExactLimitedResponse
     */
    'shipping_service_cost'?: number;
    /**
     * 
     * @type {number}
     * @memberof ShipmentExactLimitedResponse
     */
    'shipping_service_taxes'?: number;
    /**
     * 
     * @type {number}
     * @memberof ShipmentExactLimitedResponse
     */
    'shipping_service_vat'?: number;
    /**
     * 
     * @type {number}
     * @memberof ShipmentExactLimitedResponse
     */
    'total_shipment_product_cost'?: number;
    /**
     * 
     * @type {number}
     * @memberof ShipmentExactLimitedResponse
     */
    'total_shipment_tax_cost'?: number;
    /**
     * 
     * @type {number}
     * @memberof ShipmentExactLimitedResponse
     */
    'total_shipment_vat_cost'?: number;
    /**
     * 
     * @type {number}
     * @memberof ShipmentExactLimitedResponse
     */
    'total_shipping_service_cost'?: number;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactLimitedResponse
     */
    'vat_number'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactLimitedResponse
     */
    'shipment_type'?: string;
    /**
     * 
     * @type {number}
     * @memberof ShipmentExactLimitedResponse
     */
    'shipment_destination_vat_rate'?: number;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactLimitedResponse
     */
    'total_shipment_vat'?: string;
    /**
     * 
     * @type {number}
     * @memberof ShipmentExactLimitedResponse
     */
    'total_keys_shipped'?: number;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactLimitedResponse
     */
    'grant_id'?: string | null;
}


/**
 * 
 * @export
 * @interface ShipmentExactRequest
 */
export interface ShipmentExactRequest {
    /**
     * The ID of the entity through which a purchase order was submitted. Includes resellers and Yubico itself (channelpartner ID 1).
     * @type {number}
     * @memberof ShipmentExactRequest
     */
    'channelpartner_id'?: number;
    /**
     * 
     * @type {ShipmentDeliveryTypeEnum}
     * @memberof ShipmentExactRequest
     */
    'delivery_type'?: ShipmentDeliveryTypeEnum;
    /**
     * Two-letter country code, see [Country codes](https://docs.yubico.com/cloud-services/yubienterprise/delivery/multiple-req.html#country-codes).
     * @type {string}
     * @memberof ShipmentExactRequest
     */
    'country_code_2': string;
    /**
     * Recipient company name. A recipient first name and last name OR a recipient company name is required. When shipping to a residential address, do not provide a company name to avoid delivery issues. A company name should only be provided when sending to a commercial address.
     * @type {string}
     * @memberof ShipmentExactRequest
     */
    'recipient'?: string;
    /**
     * The address to which an email with the tracking number of the shipment will be sent.
     * @type {string}
     * @memberof ShipmentExactRequest
     */
    'recipient_email'?: string;
    /**
     * Recipient first name. See Recipient for more information.
     * @type {string}
     * @memberof ShipmentExactRequest
     */
    'recipient_firstname'?: string;
    /**
     * Recipient last name. See Recipient for more information.
     * @type {string}
     * @memberof ShipmentExactRequest
     */
    'recipient_lastname'?: string;
    /**
     * Recipient phone number. Ensure to submit a valid phone number to avoid delivery issues.
     * @type {string}
     * @memberof ShipmentExactRequest
     */
    'recipient_telephone': string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactRequest
     */
    'street_line1': string;
    /**
     * In case of long street names in recipient addresses, this field can be used to split the address. The maximum combined character limit for \'street_line1\' and \'street_line2\' is 120. For countries enabled on request, the maximum combined character limit is 510. See [Recipient Information](https://docs.yubico.com/cloud-services/yubienterprise/delivery/Shipments.html#restrictions-label).
     * @type {string}
     * @memberof ShipmentExactRequest
     */
    'street_line2'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactRequest
     * @deprecated
     */
    'street_line3'?: string;
    /**
     * City name in recipient address.
     * @type {string}
     * @memberof ShipmentExactRequest
     */
    'city': string;
    /**
     * Shipments to the US and Canada require a standardized two-letter region code. See [USPS Region/State Codes](https://docs.yubico.com/cloud-services/yubienterprise/delivery/Shipments.html#usps-region-state-codes).
     * @type {string}
     * @memberof ShipmentExactRequest
     */
    'region'?: string;
    /**
     * Postal code. For countries that do not use postal codes, use value \'0000\'.
     * @type {string}
     * @memberof ShipmentExactRequest
     */
    'postal_code': string;
    /**
     * Set to \'true\' to override the Yubico validation warnings if you are confident that an address is valid, or if you are using a different address validation service.
     * @type {boolean}
     * @memberof ShipmentExactRequest
     */
    'address_validation_bypass'?: boolean;
    /**
     * 
     * @type {Array<ShipmentExactRequestProduct>}
     * @memberof ShipmentExactRequest
     */
    'shipment_items': Array<ShipmentExactRequestProduct>;
}


/**
 * 
 * @export
 * @interface ShipmentExactRequestProduct
 */
export interface ShipmentExactRequestProduct {
    /**
     * The unique ID of a non-custom product, for example \'1\' for YubiKey 5 NFC. Can also refer to a custom product (legacy). See [Product and Inventory Identifiers](https://docs.yubico.com/cloud-services/yubienterprise/delivery/api-best-practices-faq.html#product-and-inventory-identifiers). To make a shipment request for *custom-programmed keys*, ensure to use the /inventory /products API to get the specific product_id.
     * @type {number}
     * @memberof ShipmentExactRequestProduct
     */
    'product_id'?: number;
    /**
     * The ID of the inventory from which to draw products. Relates to types of purchasing tier options, for example \'15\' for Primary Subscription-Advanced Tier-Initial. See [Product and Inventory Identifiers](https://docs.yubico.com/cloud-services/yubienterprise/delivery/api-best-practices-faq.html#product-and-inventory-identifiers). To make a shipment request for *custom-programmed keys*, ensure to use the /inventory /products API to get the specific inventory_product_id.
     * @type {number}
     * @memberof ShipmentExactRequestProduct
     */
    'inventory_product_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactRequestProduct
     */
    'customization_id'?: string | null;
    /**
     * The quantity of products of this type to include in the shipment request.
     * @type {number}
     * @memberof ShipmentExactRequestProduct
     */
    'shipment_product_quantity'?: number;
}
/**
 * 
 * @export
 * @interface ShipmentExactResponse
 */
export interface ShipmentExactResponse {
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactResponse
     */
    'shipment_id'?: string;
    /**
     * 
     * @type {number}
     * @memberof ShipmentExactResponse
     */
    'channelpartner_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactResponse
     */
    'channelpartner_name'?: string;
    /**
     * 
     * @type {Array<ShipmentMessage>}
     * @memberof ShipmentExactResponse
     */
    'shipment_messages'?: Array<ShipmentMessage>;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactResponse
     */
    'user_email'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactResponse
     */
    'user_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactResponse
     */
    'country_code_2'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ShipmentExactResponse
     */
    'is_delivered'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ShipmentExactResponse
     */
    'is_sent_to_fulfillment'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ShipmentExactResponse
     */
    'is_shipped'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ShipmentExactResponse
     */
    'is_post_pay'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ShipmentExactResponse
     */
    'is_tax_exempt'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ShipmentExactResponse
     */
    'address_validation_bypass'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactResponse
     * @deprecated
     */
    'organization_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactResponse
     */
    'recipient'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactResponse
     */
    'recipient_email'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactResponse
     */
    'recipient_firstname'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactResponse
     */
    'recipient_lastname'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactResponse
     */
    'recipient_telephone'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactResponse
     */
    'street_line1'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactResponse
     */
    'street_line2'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactResponse
     * @deprecated
     */
    'street_line3'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactResponse
     */
    'city'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactResponse
     */
    'region'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactResponse
     */
    'postal_code'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactResponse
     * @deprecated
     */
    'suggest_street_line1'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactResponse
     * @deprecated
     */
    'suggest_street_line2'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactResponse
     * @deprecated
     */
    'suggest_street_line3'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactResponse
     * @deprecated
     */
    'suggest_city'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactResponse
     * @deprecated
     */
    'suggest_region'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactResponse
     * @deprecated
     */
    'suggest_postal_code'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactResponse
     */
    'tracking_link'?: string;
    /**
     * 
     * @type {ShipmentDeliveryTypeEnum}
     * @memberof ShipmentExactResponse
     */
    'delivery_type'?: ShipmentDeliveryTypeEnum;
    /**
     * 
     * @type {CarrierIdentifierEnum}
     * @memberof ShipmentExactResponse
     */
    'carrier'?: CarrierIdentifierEnum;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactResponse
     */
    'tracking_number'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactResponse
     */
    'shipment_request_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactResponse
     */
    'shipment_updated_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactResponse
     */
    'shipped_date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactResponse
     */
    'delivered_date'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ShipmentExactResponse
     */
    'shipment_state_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactResponse
     */
    'shipment_state_message'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactResponse
     */
    'shipment_customer_message'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactResponse
     */
    'shipment_summary_description'?: string;
    /**
     * 
     * @type {number}
     * @memberof ShipmentExactResponse
     */
    'shipment_product_cost'?: number;
    /**
     * 
     * @type {number}
     * @memberof ShipmentExactResponse
     */
    'shipment_product_taxes'?: number;
    /**
     * 
     * @type {number}
     * @memberof ShipmentExactResponse
     */
    'shipment_product_vat'?: number;
    /**
     * 
     * @type {number}
     * @memberof ShipmentExactResponse
     */
    'shipping_service_cost'?: number;
    /**
     * 
     * @type {number}
     * @memberof ShipmentExactResponse
     */
    'shipping_service_taxes'?: number;
    /**
     * 
     * @type {number}
     * @memberof ShipmentExactResponse
     */
    'shipping_service_vat'?: number;
    /**
     * 
     * @type {number}
     * @memberof ShipmentExactResponse
     */
    'total_shipment_product_cost'?: number;
    /**
     * 
     * @type {number}
     * @memberof ShipmentExactResponse
     */
    'total_shipment_tax_cost'?: number;
    /**
     * 
     * @type {number}
     * @memberof ShipmentExactResponse
     */
    'total_shipment_vat_cost'?: number;
    /**
     * 
     * @type {number}
     * @memberof ShipmentExactResponse
     */
    'total_shipping_service_cost'?: number;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactResponse
     */
    'vat_number'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactResponse
     */
    'shipment_type'?: string;
    /**
     * 
     * @type {number}
     * @memberof ShipmentExactResponse
     */
    'shipment_destination_vat_rate'?: number;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactResponse
     */
    'total_shipment_vat'?: string;
    /**
     * 
     * @type {number}
     * @memberof ShipmentExactResponse
     */
    'total_keys_shipped'?: number;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactResponse
     */
    'grant_id'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ShipmentExactResponse
     */
    'total_cost'?: number;
    /**
     * 
     * @type {Array<ShipmentExactResponseProduct>}
     * @memberof ShipmentExactResponse
     */
    'shipment_items'?: Array<ShipmentExactResponseProduct>;
}


/**
 * 
 * @export
 * @interface ShipmentExactResponseAllOf
 */
export interface ShipmentExactResponseAllOf {
    /**
     * 
     * @type {number}
     * @memberof ShipmentExactResponseAllOf
     */
    'total_cost'?: number;
    /**
     * 
     * @type {Array<ShipmentExactResponseProduct>}
     * @memberof ShipmentExactResponseAllOf
     */
    'shipment_items'?: Array<ShipmentExactResponseProduct>;
}
/**
 * 
 * @export
 * @interface ShipmentExactResponseProduct
 */
export interface ShipmentExactResponseProduct {
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactResponseProduct
     */
    'shipment_product_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactResponseProduct
     */
    'shipment_id'?: string;
    /**
     * 
     * @type {number}
     * @memberof ShipmentExactResponseProduct
     */
    'product_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactResponseProduct
     */
    'product_name'?: string;
    /**
     * 
     * @type {number}
     * @memberof ShipmentExactResponseProduct
     */
    'inventory_product_id'?: number;
    /**
     * 
     * @type {number}
     * @memberof ShipmentExactResponseProduct
     */
    'shipment_product_quantity'?: number;
    /**
     * 
     * @type {number}
     * @memberof ShipmentExactResponseProduct
     */
    'shipment_product_line_cost'?: number;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactResponseProduct
     */
    'customization_id'?: string;
}
/**
 * 
 * @export
 * @interface ShipmentExactResponseProductWithData
 */
export interface ShipmentExactResponseProductWithData {
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactResponseProductWithData
     */
    'shipment_product_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactResponseProductWithData
     */
    'shipment_id'?: string;
    /**
     * 
     * @type {number}
     * @memberof ShipmentExactResponseProductWithData
     */
    'product_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactResponseProductWithData
     */
    'product_name'?: string;
    /**
     * 
     * @type {number}
     * @memberof ShipmentExactResponseProductWithData
     */
    'inventory_product_id'?: number;
    /**
     * 
     * @type {number}
     * @memberof ShipmentExactResponseProductWithData
     */
    'shipment_product_quantity'?: number;
    /**
     * 
     * @type {number}
     * @memberof ShipmentExactResponseProductWithData
     */
    'shipment_product_line_cost'?: number;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactResponseProductWithData
     */
    'customization_id'?: string;
    /**
     * 
     * @type {Array<ShipmentProductData>}
     * @memberof ShipmentExactResponseProductWithData
     */
    'shipment_product_data'?: Array<ShipmentProductData>;
}
/**
 * 
 * @export
 * @interface ShipmentExactResponseProductWithDataAllOf
 */
export interface ShipmentExactResponseProductWithDataAllOf {
    /**
     * 
     * @type {Array<ShipmentProductData>}
     * @memberof ShipmentExactResponseProductWithDataAllOf
     */
    'shipment_product_data'?: Array<ShipmentProductData>;
}
/**
 * 
 * @export
 * @interface ShipmentExactResponseWithData
 */
export interface ShipmentExactResponseWithData {
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactResponseWithData
     */
    'shipment_id'?: string;
    /**
     * 
     * @type {number}
     * @memberof ShipmentExactResponseWithData
     */
    'channelpartner_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactResponseWithData
     */
    'channelpartner_name'?: string;
    /**
     * 
     * @type {Array<ShipmentMessage>}
     * @memberof ShipmentExactResponseWithData
     */
    'shipment_messages'?: Array<ShipmentMessage>;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactResponseWithData
     */
    'user_email'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactResponseWithData
     */
    'user_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactResponseWithData
     */
    'country_code_2'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ShipmentExactResponseWithData
     */
    'is_delivered'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ShipmentExactResponseWithData
     */
    'is_sent_to_fulfillment'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ShipmentExactResponseWithData
     */
    'is_shipped'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ShipmentExactResponseWithData
     */
    'is_post_pay'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ShipmentExactResponseWithData
     */
    'is_tax_exempt'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ShipmentExactResponseWithData
     */
    'address_validation_bypass'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactResponseWithData
     * @deprecated
     */
    'organization_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactResponseWithData
     */
    'recipient'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactResponseWithData
     */
    'recipient_email'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactResponseWithData
     */
    'recipient_firstname'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactResponseWithData
     */
    'recipient_lastname'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactResponseWithData
     */
    'recipient_telephone'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactResponseWithData
     */
    'street_line1'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactResponseWithData
     */
    'street_line2'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactResponseWithData
     * @deprecated
     */
    'street_line3'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactResponseWithData
     */
    'city'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactResponseWithData
     */
    'region'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactResponseWithData
     */
    'postal_code'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactResponseWithData
     * @deprecated
     */
    'suggest_street_line1'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactResponseWithData
     * @deprecated
     */
    'suggest_street_line2'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactResponseWithData
     * @deprecated
     */
    'suggest_street_line3'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactResponseWithData
     * @deprecated
     */
    'suggest_city'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactResponseWithData
     * @deprecated
     */
    'suggest_region'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactResponseWithData
     * @deprecated
     */
    'suggest_postal_code'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactResponseWithData
     */
    'tracking_link'?: string;
    /**
     * 
     * @type {ShipmentDeliveryTypeEnum}
     * @memberof ShipmentExactResponseWithData
     */
    'delivery_type'?: ShipmentDeliveryTypeEnum;
    /**
     * 
     * @type {CarrierIdentifierEnum}
     * @memberof ShipmentExactResponseWithData
     */
    'carrier'?: CarrierIdentifierEnum;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactResponseWithData
     */
    'tracking_number'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactResponseWithData
     */
    'shipment_request_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactResponseWithData
     */
    'shipment_updated_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactResponseWithData
     */
    'shipped_date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactResponseWithData
     */
    'delivered_date'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ShipmentExactResponseWithData
     */
    'shipment_state_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactResponseWithData
     */
    'shipment_state_message'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactResponseWithData
     */
    'shipment_customer_message'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactResponseWithData
     */
    'shipment_summary_description'?: string;
    /**
     * 
     * @type {number}
     * @memberof ShipmentExactResponseWithData
     */
    'shipment_product_cost'?: number;
    /**
     * 
     * @type {number}
     * @memberof ShipmentExactResponseWithData
     */
    'shipment_product_taxes'?: number;
    /**
     * 
     * @type {number}
     * @memberof ShipmentExactResponseWithData
     */
    'shipment_product_vat'?: number;
    /**
     * 
     * @type {number}
     * @memberof ShipmentExactResponseWithData
     */
    'shipping_service_cost'?: number;
    /**
     * 
     * @type {number}
     * @memberof ShipmentExactResponseWithData
     */
    'shipping_service_taxes'?: number;
    /**
     * 
     * @type {number}
     * @memberof ShipmentExactResponseWithData
     */
    'shipping_service_vat'?: number;
    /**
     * 
     * @type {number}
     * @memberof ShipmentExactResponseWithData
     */
    'total_shipment_product_cost'?: number;
    /**
     * 
     * @type {number}
     * @memberof ShipmentExactResponseWithData
     */
    'total_shipment_tax_cost'?: number;
    /**
     * 
     * @type {number}
     * @memberof ShipmentExactResponseWithData
     */
    'total_shipment_vat_cost'?: number;
    /**
     * 
     * @type {number}
     * @memberof ShipmentExactResponseWithData
     */
    'total_shipping_service_cost'?: number;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactResponseWithData
     */
    'vat_number'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactResponseWithData
     */
    'shipment_type'?: string;
    /**
     * 
     * @type {number}
     * @memberof ShipmentExactResponseWithData
     */
    'shipment_destination_vat_rate'?: number;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactResponseWithData
     */
    'total_shipment_vat'?: string;
    /**
     * 
     * @type {number}
     * @memberof ShipmentExactResponseWithData
     */
    'total_keys_shipped'?: number;
    /**
     * 
     * @type {string}
     * @memberof ShipmentExactResponseWithData
     */
    'grant_id'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ShipmentExactResponseWithData
     */
    'total_cost'?: number;
    /**
     * 
     * @type {Array<ShipmentExactResponseProductWithData>}
     * @memberof ShipmentExactResponseWithData
     */
    'shipment_items'?: Array<ShipmentExactResponseProductWithData>;
}


/**
 * 
 * @export
 * @interface ShipmentExactResponseWithDataAllOf
 */
export interface ShipmentExactResponseWithDataAllOf {
    /**
     * 
     * @type {number}
     * @memberof ShipmentExactResponseWithDataAllOf
     */
    'total_cost'?: number;
    /**
     * 
     * @type {Array<ShipmentExactResponseProductWithData>}
     * @memberof ShipmentExactResponseWithDataAllOf
     */
    'shipment_items'?: Array<ShipmentExactResponseProductWithData>;
}
/**
 * 
 * @export
 * @interface ShipmentExactResultSet
 */
export interface ShipmentExactResultSet {
    /**
     * 
     * @type {number}
     * @memberof ShipmentExactResultSet
     */
    'count': number;
    /**
     * 
     * @type {number}
     * @memberof ShipmentExactResultSet
     */
    'total_count': number;
    /**
     * 
     * @type {Array<ShipmentExactLimitedResponse>}
     * @memberof ShipmentExactResultSet
     */
    'shipments'?: Array<ShipmentExactLimitedResponse>;
}
/**
 * 
 * @export
 * @interface ShipmentExactResultSetAllOf
 */
export interface ShipmentExactResultSetAllOf {
    /**
     * 
     * @type {Array<ShipmentExactLimitedResponse>}
     * @memberof ShipmentExactResultSetAllOf
     */
    'shipments'?: Array<ShipmentExactLimitedResponse>;
}
/**
 * 
 * @export
 * @interface ShipmentHistoryMessage
 */
export interface ShipmentHistoryMessage {
    /**
     * 
     * @type {string}
     * @memberof ShipmentHistoryMessage
     */
    'shipment_message_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentHistoryMessage
     */
    'shipment_message_body'?: string;
}
/**
 * 
 * @export
 * @interface ShipmentMessage
 */
export interface ShipmentMessage {
    /**
     * 
     * @type {string}
     * @memberof ShipmentMessage
     */
    'shipment_message_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentMessage
     */
    'shipment_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentMessage
     */
    'shipment_message_body'?: string;
}
/**
 * 
 * @export
 * @interface ShipmentProduct
 */
export interface ShipmentProduct {
    /**
     * 
     * @type {string}
     * @memberof ShipmentProduct
     */
    'shipment_product_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentProduct
     */
    'shipment_id'?: string;
    /**
     * 
     * @type {number}
     * @memberof ShipmentProduct
     */
    'product_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ShipmentProduct
     */
    'product_name'?: string;
    /**
     * 
     * @type {number}
     * @memberof ShipmentProduct
     */
    'shipment_product_quantity'?: number;
    /**
     * 
     * @type {number}
     * @memberof ShipmentProduct
     */
    'shipment_product_line_cost'?: number;
}
/**
 * 
 * @export
 * @interface ShipmentProductData
 */
export interface ShipmentProductData {
    /**
     * 
     * @type {string}
     * @memberof ShipmentProductData
     */
    'serial_number': string | null;
    /**
     * 
     * @type {string}
     * @memberof ShipmentProductData
     */
    'firmware_version': string | null;
}
/**
 * 
 * @export
 * @interface ShipmentRefundResponse
 */
export interface ShipmentRefundResponse {
    /**
     * 
     * @type {Array<ShippingRefundResponse>}
     * @memberof ShipmentRefundResponse
     */
    'shipping_refund': Array<ShippingRefundResponse>;
    /**
     * 
     * @type {Array<ProductRefundResponse>}
     * @memberof ShipmentRefundResponse
     */
    'product_refund': Array<ProductRefundResponse>;
}
/**
 * 
 * @export
 * @interface ShipmentRequestor
 */
export interface ShipmentRequestor {
    /**
     * 
     * @type {string}
     * @memberof ShipmentRequestor
     */
    'user_email'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentRequestor
     */
    'user_id'?: string;
}
/**
 * 
 * @export
 * @interface ShipmentResponseLimited
 */
export interface ShipmentResponseLimited {
    /**
     * 
     * @type {string}
     * @memberof ShipmentResponseLimited
     */
    'shipment_id'?: string;
    /**
     * 
     * @type {number}
     * @memberof ShipmentResponseLimited
     */
    'channelpartner_id': number;
    /**
     * 
     * @type {string}
     * @memberof ShipmentResponseLimited
     */
    'channelpartner_name': string;
    /**
     * 
     * @type {Array<ShipmentMessage>}
     * @memberof ShipmentResponseLimited
     */
    'shipment_messages'?: Array<ShipmentMessage>;
    /**
     * 
     * @type {string}
     * @memberof ShipmentResponseLimited
     */
    'user_email'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentResponseLimited
     */
    'user_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentResponseLimited
     */
    'country_code_2'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ShipmentResponseLimited
     */
    'is_delivered': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ShipmentResponseLimited
     */
    'is_sent_to_fulfillment': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ShipmentResponseLimited
     */
    'is_shipped': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ShipmentResponseLimited
     */
    'is_post_pay'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ShipmentResponseLimited
     */
    'is_tax_exempt'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ShipmentResponseLimited
     * @deprecated
     */
    'organization_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentResponseLimited
     */
    'recipient'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentResponseLimited
     */
    'recipient_email'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentResponseLimited
     */
    'recipient_firstname'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentResponseLimited
     */
    'recipient_lastname'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentResponseLimited
     */
    'recipient_telephone'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentResponseLimited
     */
    'street_line1'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentResponseLimited
     */
    'street_line2'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentResponseLimited
     * @deprecated
     */
    'street_line3'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentResponseLimited
     */
    'city'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentResponseLimited
     */
    'region'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentResponseLimited
     */
    'postal_code'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentResponseLimited
     * @deprecated
     */
    'suggest_street_line1'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentResponseLimited
     * @deprecated
     */
    'suggest_street_line2'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentResponseLimited
     * @deprecated
     */
    'suggest_street_line3'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentResponseLimited
     * @deprecated
     */
    'suggest_city'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentResponseLimited
     * @deprecated
     */
    'suggest_region'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentResponseLimited
     * @deprecated
     */
    'suggest_postal_code'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentResponseLimited
     */
    'tracking_link'?: string;
    /**
     * 
     * @type {ShipmentDeliveryTypeEnum}
     * @memberof ShipmentResponseLimited
     */
    'delivery_type'?: ShipmentDeliveryTypeEnum;
    /**
     * 
     * @type {CarrierIdentifierEnum}
     * @memberof ShipmentResponseLimited
     */
    'carrier'?: CarrierIdentifierEnum;
    /**
     * 
     * @type {string}
     * @memberof ShipmentResponseLimited
     */
    'tracking_number'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentResponseLimited
     */
    'shipment_request_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentResponseLimited
     */
    'shipment_updated_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentResponseLimited
     */
    'shipped_date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShipmentResponseLimited
     */
    'delivered_date'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ShipmentResponseLimited
     */
    'shipment_state_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ShipmentResponseLimited
     */
    'shipment_state_message'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentResponseLimited
     */
    'shipment_customer_message'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentResponseLimited
     */
    'shipment_summary_description'?: string;
    /**
     * 
     * @type {number}
     * @memberof ShipmentResponseLimited
     */
    'shipment_product_cost'?: number;
    /**
     * 
     * @type {number}
     * @memberof ShipmentResponseLimited
     */
    'shipment_product_taxes'?: number;
    /**
     * 
     * @type {number}
     * @memberof ShipmentResponseLimited
     */
    'shipment_product_vat'?: number;
    /**
     * 
     * @type {number}
     * @memberof ShipmentResponseLimited
     */
    'shipping_service_cost'?: number;
    /**
     * 
     * @type {number}
     * @memberof ShipmentResponseLimited
     */
    'shipping_service_taxes'?: number;
    /**
     * 
     * @type {number}
     * @memberof ShipmentResponseLimited
     */
    'shipping_service_vat'?: number;
    /**
     * 
     * @type {number}
     * @memberof ShipmentResponseLimited
     */
    'total_shipment_product_cost'?: number;
    /**
     * 
     * @type {number}
     * @memberof ShipmentResponseLimited
     */
    'total_shipment_tax_cost'?: number;
    /**
     * 
     * @type {number}
     * @memberof ShipmentResponseLimited
     */
    'total_shipment_vat_cost'?: number;
    /**
     * 
     * @type {number}
     * @memberof ShipmentResponseLimited
     */
    'total_shipping_service_cost'?: number;
    /**
     * 
     * @type {string}
     * @memberof ShipmentResponseLimited
     */
    'vat_number'?: string;
    /**
     * 
     * @type {number}
     * @memberof ShipmentResponseLimited
     */
    'shipment_destination_vat_rate'?: number;
    /**
     * 
     * @type {string}
     * @memberof ShipmentResponseLimited
     */
    'total_shipment_vat'?: string;
    /**
     * 
     * @type {number}
     * @memberof ShipmentResponseLimited
     */
    'total_keys_shipped'?: number;
    /**
     * 
     * @type {InventoryTypeEnum}
     * @memberof ShipmentResponseLimited
     */
    'inventory_type': InventoryTypeEnum;
}


/**
 * 
 * @export
 * @interface ShipmentResultSet
 */
export interface ShipmentResultSet {
    /**
     * 
     * @type {number}
     * @memberof ShipmentResultSet
     */
    'count': number;
    /**
     * 
     * @type {number}
     * @memberof ShipmentResultSet
     */
    'total_count': number;
    /**
     * 
     * @type {Array<ShipmentResponseLimited>}
     * @memberof ShipmentResultSet
     */
    'shipments'?: Array<ShipmentResponseLimited>;
}
/**
 * 
 * @export
 * @interface ShipmentResultSetAllOf
 */
export interface ShipmentResultSetAllOf {
    /**
     * 
     * @type {Array<ShipmentResponseLimited>}
     * @memberof ShipmentResultSetAllOf
     */
    'shipments'?: Array<ShipmentResponseLimited>;
}
/**
 * See more details at https://console.yubico.com/help/Best_Practices_and_Troubleshooting.html#shipping-status-codes.
 * @export
 * @interface ShipmentState
 */
export interface ShipmentState {
    /**
     * 
     * @type {number}
     * @memberof ShipmentState
     */
    'shipment_state_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ShipmentState
     */
    'shipment_state_message'?: string;
}
/**
 * 
 * @export
 * @interface ShippingAccount
 */
export interface ShippingAccount {
    /**
     * 
     * @type {string}
     * @memberof ShippingAccount
     */
    'organizations_shippingaccount_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShippingAccount
     * @deprecated
     */
    'organization_id'?: string;
    /**
     * 
     * @type {number}
     * @memberof ShippingAccount
     */
    'currency_id'?: number;
    /**
     * 
     * @type {number}
     * @memberof ShippingAccount
     */
    'shippingaccount_balance'?: number;
}
/**
 * 
 * @export
 * @interface ShippingRefundResponse
 */
export interface ShippingRefundResponse {
    /**
     * 
     * @type {string}
     * @memberof ShippingRefundResponse
     */
    'shipping_refund_id': string;
    /**
     * 
     * @type {number}
     * @memberof ShippingRefundResponse
     */
    'shipping_fee_refunded': number;
    /**
     * 
     * @type {number}
     * @memberof ShippingRefundResponse
     */
    'shipping_tax_refunded': number;
    /**
     * 
     * @type {number}
     * @memberof ShippingRefundResponse
     */
    'shipping_vat_refunded': number;
    /**
     * 
     * @type {string}
     * @memberof ShippingRefundResponse
     */
    'refund_date': string;
}
/**
 * 
 * @export
 * @interface StandardErrorDetail
 */
export interface StandardErrorDetail {
    /**
     * The message explaining the detailed error in text.
     * @type {string}
     * @memberof StandardErrorDetail
     */
    'message': string;
    /**
     * json path to the field, if the error detail refers to a field
     * @type {string}
     * @memberof StandardErrorDetail
     */
    'field'?: string;
}
/**
 * 
 * @export
 * @interface StandardErrorResult
 */
export interface StandardErrorResult {
    /**
     * 
     * @type {string}
     * @memberof StandardErrorResult
     */
    'code': string;
    /**
     * The error message in text
     * @type {string}
     * @memberof StandardErrorResult
     */
    'message'?: string;
    /**
     * A list of details of each distinct problem encountered. Omitted when empty
     * @type {Array<StandardErrorDetail>}
     * @memberof StandardErrorResult
     */
    'errors'?: Array<StandardErrorDetail>;
}
/**
 * 0: N/A (no subscription) 1: Primary subscription 2: Backup subscription 3: Primary Standard subscription 2.0 4: Backup Standard subscription 2.0 5: Primary Plus subscription 2.0 6: Backup Plus subscription 2.0 
 * @export
 * @enum {string}
 */

export enum SubscriptionTypeEnum {
    NoSubscription = 0,
    PrimarySubscription = 1,
    BackupSubscription = 2,
    Sub2PrimaryStandard = 3,
    Sub2BackupStandard = 4,
    Sub2PrimaryPlus = 5,
    Sub2BackupPlus = 6
}


/**
 * 
 * @export
 * @interface TaxAccount
 */
export interface TaxAccount {
    /**
     * 
     * @type {string}
     * @memberof TaxAccount
     */
    'organizations_taxaccount_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TaxAccount
     * @deprecated
     */
    'organization_id'?: string;
    /**
     * 
     * @type {number}
     * @memberof TaxAccount
     */
    'currency_id'?: number;
    /**
     * 
     * @type {number}
     * @memberof TaxAccount
     */
    'taxaccount_balance'?: number;
}
/**
 * 
 * @export
 * @interface TokenMetadata
 */
export interface TokenMetadata {
    /**
     * 
     * @type {string}
     * @memberof TokenMetadata
     */
    'token_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TokenMetadata
     */
    'last_used'?: string;
    /**
     * 
     * @type {string}
     * @memberof TokenMetadata
     */
    'create_time'?: string;
    /**
     * 
     * @type {string}
     * @memberof TokenMetadata
     */
    'expire_time'?: string;
}
/**
 * 
 * @export
 * @interface Tracking
 */
export interface Tracking {
    /**
     * 
     * @type {CarrierIdentifierEnum}
     * @memberof Tracking
     */
    'carrier'?: CarrierIdentifierEnum;
    /**
     * 
     * @type {string}
     * @memberof Tracking
     */
    'tracking_number'?: string;
    /**
     * 
     * @type {string}
     * @memberof Tracking
     */
    'tracking_link'?: string;
}


/**
 * 
 * @export
 * @interface UpdateCustomizationLabelRequest
 */
export interface UpdateCustomizationLabelRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateCustomizationLabelRequest
     */
    'name'?: string;
}
/**
 * 
 * @export
 * @interface UserInvite
 */
export interface UserInvite {
    /**
     * 
     * @type {string}
     * @memberof UserInvite
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof UserInvite
     */
    'role'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserInvite
     */
    'roles'?: Array<string>;
}
/**
 * 
 * @export
 * @interface VATAccount
 */
export interface VATAccount {
    /**
     * 
     * @type {string}
     * @memberof VATAccount
     */
    'organizations_vataccount_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof VATAccount
     * @deprecated
     */
    'organization_id'?: string;
    /**
     * 
     * @type {number}
     * @memberof VATAccount
     */
    'currency_id'?: number;
    /**
     * 
     * @type {number}
     * @memberof VATAccount
     */
    'vataccount_balance'?: number;
}
/**
 * Deprecated: To be replaced by \'#/components/schemas/StandardErrorResult\'
 * @export
 * @interface ValidationError
 */
export interface ValidationError {
    /**
     * 
     * @type {string}
     * @memberof ValidationError
     */
    'code': string;
    /**
     * The error message in text
     * @type {string}
     * @memberof ValidationError
     */
    'message'?: string;
    /**
     * A list of details of each distinct problem encountered. Omitted when empty
     * @type {Array<StandardErrorDetail>}
     * @memberof ValidationError
     */
    'errors'?: Array<StandardErrorDetail>;
}

/**
 * AccountsApi - axios parameter creator
 * @export
 */
export const AccountsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns the account balances for organization in context. Amounts returned are dollars * 100 
         * @summary Lists account balances for the organization of the current user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountBalances: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/accountbalances`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AccountsApi - functional programming interface
 * @export
 */
export const AccountsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AccountsApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns the account balances for organization in context. Amounts returned are dollars * 100 
         * @summary Lists account balances for the organization of the current user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAccountBalances(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccountBalances>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAccountBalances(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AccountsApi - factory interface
 * @export
 */
export const AccountsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AccountsApiFp(configuration)
    return {
        /**
         * Returns the account balances for organization in context. Amounts returned are dollars * 100 
         * @summary Lists account balances for the organization of the current user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountBalances(options?: any): AxiosPromise<AccountBalances> {
            return localVarFp.getAccountBalances(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AccountsApi - object-oriented interface
 * @export
 * @class AccountsApi
 * @extends {BaseAPI}
 */
export class AccountsApi extends BaseAPI {
    /**
     * Returns the account balances for organization in context. Amounts returned are dollars * 100 
     * @summary Lists account balances for the organization of the current user.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsApi
     */
    public getAccountBalances(options?: AxiosRequestConfig) {
        return AccountsApiFp(this.configuration).getAccountBalances(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * AddressesApi - axios parameter creator
 * @export
 */
export const AddressesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Validates an address to make sure that it exists and is deliverable. Suggested addresses appear in the payload.
         * @summary Validates an address.
         * @param {Address} [body] Address body to use
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateAddress: async (body?: Address, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/validate-address`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AddressesApi - functional programming interface
 * @export
 */
export const AddressesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AddressesApiAxiosParamCreator(configuration)
    return {
        /**
         * Validates an address to make sure that it exists and is deliverable. Suggested addresses appear in the payload.
         * @summary Validates an address.
         * @param {Address} [body] Address body to use
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validateAddress(body?: Address, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AddressValidationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validateAddress(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AddressesApi - factory interface
 * @export
 */
export const AddressesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AddressesApiFp(configuration)
    return {
        /**
         * Validates an address to make sure that it exists and is deliverable. Suggested addresses appear in the payload.
         * @summary Validates an address.
         * @param {Address} [body] Address body to use
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateAddress(body?: Address, options?: any): AxiosPromise<AddressValidationResponse> {
            return localVarFp.validateAddress(body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AddressesApi - object-oriented interface
 * @export
 * @class AddressesApi
 * @extends {BaseAPI}
 */
export class AddressesApi extends BaseAPI {
    /**
     * Validates an address to make sure that it exists and is deliverable. Suggested addresses appear in the payload.
     * @summary Validates an address.
     * @param {Address} [body] Address body to use
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressesApi
     */
    public validateAddress(body?: Address, options?: AxiosRequestConfig) {
        return AddressesApiFp(this.configuration).validateAddress(body, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * AuthApi - axios parameter creator
 * @export
 */
export const AuthApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Accept the terms and conditions for the current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authMeAcceptTermsPost: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/auth/me/accept-terms`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get information about the currently authenticated user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authMeGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/auth/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Set an active organization to associate with the current session
         * @param {AuthSetActiveOrgPostRequest} [authSetActiveOrgPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authSetActiveOrgPost: async (authSetActiveOrgPostRequest?: AuthSetActiveOrgPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/auth/set-active-org`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(authSetActiveOrgPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a long-lived revokable machine token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateAPIToken: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/auth/machine-token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Log out of the current user session
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logout: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/auth/logout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Revoke the machine token for the current user/org combination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revokeAPIToken: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/auth/machine-token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuthApi - functional programming interface
 * @export
 */
export const AuthApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuthApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Accept the terms and conditions for the current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authMeAcceptTermsPost(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authMeAcceptTermsPost(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get information about the currently authenticated user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authMeGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthUser>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authMeGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Set an active organization to associate with the current session
         * @param {AuthSetActiveOrgPostRequest} [authSetActiveOrgPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authSetActiveOrgPost(authSetActiveOrgPostRequest?: AuthSetActiveOrgPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authSetActiveOrgPost(authSetActiveOrgPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get a long-lived revokable machine token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateAPIToken(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateAPIToken(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Log out of the current user session
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async logout(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.logout(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Revoke the machine token for the current user/org combination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async revokeAPIToken(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.revokeAPIToken(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AuthApi - factory interface
 * @export
 */
export const AuthApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuthApiFp(configuration)
    return {
        /**
         * 
         * @summary Accept the terms and conditions for the current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authMeAcceptTermsPost(options?: any): AxiosPromise<void> {
            return localVarFp.authMeAcceptTermsPost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get information about the currently authenticated user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authMeGet(options?: any): AxiosPromise<AuthUser> {
            return localVarFp.authMeGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Set an active organization to associate with the current session
         * @param {AuthSetActiveOrgPostRequest} [authSetActiveOrgPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authSetActiveOrgPost(authSetActiveOrgPostRequest?: AuthSetActiveOrgPostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.authSetActiveOrgPost(authSetActiveOrgPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a long-lived revokable machine token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateAPIToken(options?: any): AxiosPromise<string> {
            return localVarFp.generateAPIToken(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Log out of the current user session
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logout(options?: any): AxiosPromise<void> {
            return localVarFp.logout(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Revoke the machine token for the current user/org combination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revokeAPIToken(options?: any): AxiosPromise<string> {
            return localVarFp.revokeAPIToken(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AuthApi - object-oriented interface
 * @export
 * @class AuthApi
 * @extends {BaseAPI}
 */
export class AuthApi extends BaseAPI {
    /**
     * 
     * @summary Accept the terms and conditions for the current user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public authMeAcceptTermsPost(options?: AxiosRequestConfig) {
        return AuthApiFp(this.configuration).authMeAcceptTermsPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get information about the currently authenticated user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public authMeGet(options?: AxiosRequestConfig) {
        return AuthApiFp(this.configuration).authMeGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Set an active organization to associate with the current session
     * @param {AuthSetActiveOrgPostRequest} [authSetActiveOrgPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public authSetActiveOrgPost(authSetActiveOrgPostRequest?: AuthSetActiveOrgPostRequest, options?: AxiosRequestConfig) {
        return AuthApiFp(this.configuration).authSetActiveOrgPost(authSetActiveOrgPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a long-lived revokable machine token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public generateAPIToken(options?: AxiosRequestConfig) {
        return AuthApiFp(this.configuration).generateAPIToken(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Log out of the current user session
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public logout(options?: AxiosRequestConfig) {
        return AuthApiFp(this.configuration).logout(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Revoke the machine token for the current user/org combination
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public revokeAPIToken(options?: AxiosRequestConfig) {
        return AuthApiFp(this.configuration).revokeAPIToken(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ChannelpartnersApi - axios parameter creator
 * @export
 */
export const ChannelpartnersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns the set of channel partners for an organization. Note that channelpartner is renamed to reseller, including all prefixes. The expected values for these fields remain the same.
         * @summary Get all channel partners relevant to an org
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllChannelPartnersForOrg: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/channelpartners`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ChannelpartnersApi - functional programming interface
 * @export
 */
export const ChannelpartnersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ChannelpartnersApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns the set of channel partners for an organization. Note that channelpartner is renamed to reseller, including all prefixes. The expected values for these fields remain the same.
         * @summary Get all channel partners relevant to an org
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllChannelPartnersForOrg(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChannelPartnerResultSet>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllChannelPartnersForOrg(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ChannelpartnersApi - factory interface
 * @export
 */
export const ChannelpartnersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ChannelpartnersApiFp(configuration)
    return {
        /**
         * Returns the set of channel partners for an organization. Note that channelpartner is renamed to reseller, including all prefixes. The expected values for these fields remain the same.
         * @summary Get all channel partners relevant to an org
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllChannelPartnersForOrg(options?: any): AxiosPromise<ChannelPartnerResultSet> {
            return localVarFp.getAllChannelPartnersForOrg(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ChannelpartnersApi - object-oriented interface
 * @export
 * @class ChannelpartnersApi
 * @extends {BaseAPI}
 */
export class ChannelpartnersApi extends BaseAPI {
    /**
     * Returns the set of channel partners for an organization. Note that channelpartner is renamed to reseller, including all prefixes. The expected values for these fields remain the same.
     * @summary Get all channel partners relevant to an org
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChannelpartnersApi
     */
    public getAllChannelPartnersForOrg(options?: AxiosRequestConfig) {
        return ChannelpartnersApiFp(this.configuration).getAllChannelPartnersForOrg(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * CountriesApi - axios parameter creator
 * @export
 */
export const CountriesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Download a CSV with countries including codes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadCountries: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/countries/csv`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List all available countries
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCountries: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/countries`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CountriesApi - functional programming interface
 * @export
 */
export const CountriesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CountriesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Download a CSV with countries including codes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadCountries(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadCountries(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary List all available countries
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listCountries(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CountryResultSet>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listCountries(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CountriesApi - factory interface
 * @export
 */
export const CountriesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CountriesApiFp(configuration)
    return {
        /**
         * 
         * @summary Download a CSV with countries including codes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadCountries(options?: any): AxiosPromise<string> {
            return localVarFp.downloadCountries(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List all available countries
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCountries(options?: any): AxiosPromise<CountryResultSet> {
            return localVarFp.listCountries(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CountriesApi - object-oriented interface
 * @export
 * @class CountriesApi
 * @extends {BaseAPI}
 */
export class CountriesApi extends BaseAPI {
    /**
     * 
     * @summary Download a CSV with countries including codes
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CountriesApi
     */
    public downloadCountries(options?: AxiosRequestConfig) {
        return CountriesApiFp(this.configuration).downloadCountries(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List all available countries
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CountriesApi
     */
    public listCountries(options?: AxiosRequestConfig) {
        return CountriesApiFp(this.configuration).listCountries(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * CustomizationsApi - axios parameter creator
 * @export
 */
export const CustomizationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns a list of products and quantities available for a specific customization 
         * @summary Gets a list of products and quantities available for a specific customization
         * @param {string} customizationId ID of the Customization for which the inventory is being fetched
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomizationInventory: async (customizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customizationId' is not null or undefined
            assertParamExists('getCustomizationInventory', 'customizationId', customizationId)
            const localVarPath = `/v1/customizations/{customizationId}`
                .replace(`{${"customizationId"}}`, encodeURIComponent(String(customizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get customizations
         * @param {number} [offset] Number of items to offset the list by (used for pagination)
         * @param {number} [limit] Number of items to limit the list by (used for pagination)
         * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
         * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
         * @param {ListAllUsersInOrganizationSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
         * @param {ListAllUsersInOrganizationSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
         * @param {boolean} [advancedSearch] Advanced search mode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomizations: async (offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: ListAllUsersInOrganizationSearchParameter, searchField?: ListAllUsersInOrganizationSearchParameter, advancedSearch?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/customizations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "authorization", configuration)

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sort_direction'] = sortDirection;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (searchField !== undefined) {
                localVarQueryParameter['search_field'] = searchField;
            }

            if (advancedSearch !== undefined) {
                localVarQueryParameter['advanced_search'] = advancedSearch;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a list that describes customization searchable fields
         * @summary Lists searchable fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCustomizationSearchDescription: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/customizations/search-description`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Updates an existing customization\'s name
         * @param {string} customizationId ID of the Customization for which the name is being updated
         * @param {UpdateCustomizationLabelRequest} [updateCustomizationLabelRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCustomizationLabel: async (customizationId: string, updateCustomizationLabelRequest?: UpdateCustomizationLabelRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customizationId' is not null or undefined
            assertParamExists('updateCustomizationLabel', 'customizationId', customizationId)
            const localVarPath = `/v1/customizations/{customizationId}`
                .replace(`{${"customizationId"}}`, encodeURIComponent(String(customizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCustomizationLabelRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CustomizationsApi - functional programming interface
 * @export
 */
export const CustomizationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CustomizationsApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns a list of products and quantities available for a specific customization 
         * @summary Gets a list of products and quantities available for a specific customization
         * @param {string} customizationId ID of the Customization for which the inventory is being fetched
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomizationInventory(customizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomizationWithRedeemableInventory>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomizationInventory(customizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get customizations
         * @param {number} [offset] Number of items to offset the list by (used for pagination)
         * @param {number} [limit] Number of items to limit the list by (used for pagination)
         * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
         * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
         * @param {ListAllUsersInOrganizationSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
         * @param {ListAllUsersInOrganizationSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
         * @param {boolean} [advancedSearch] Advanced search mode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomizations(offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: ListAllUsersInOrganizationSearchParameter, searchField?: ListAllUsersInOrganizationSearchParameter, advancedSearch?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomizationResultSet>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomizations(offset, limit, sortBy, sortDirection, search, searchField, advancedSearch, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns a list that describes customization searchable fields
         * @summary Lists searchable fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listCustomizationSearchDescription(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchDescription>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listCustomizationSearchDescription(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Updates an existing customization\'s name
         * @param {string} customizationId ID of the Customization for which the name is being updated
         * @param {UpdateCustomizationLabelRequest} [updateCustomizationLabelRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCustomizationLabel(customizationId: string, updateCustomizationLabelRequest?: UpdateCustomizationLabelRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomizationWithRedeemableInventory>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCustomizationLabel(customizationId, updateCustomizationLabelRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CustomizationsApi - factory interface
 * @export
 */
export const CustomizationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CustomizationsApiFp(configuration)
    return {
        /**
         * Returns a list of products and quantities available for a specific customization 
         * @summary Gets a list of products and quantities available for a specific customization
         * @param {string} customizationId ID of the Customization for which the inventory is being fetched
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomizationInventory(customizationId: string, options?: any): AxiosPromise<CustomizationWithRedeemableInventory> {
            return localVarFp.getCustomizationInventory(customizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get customizations
         * @param {number} [offset] Number of items to offset the list by (used for pagination)
         * @param {number} [limit] Number of items to limit the list by (used for pagination)
         * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
         * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
         * @param {ListAllUsersInOrganizationSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
         * @param {ListAllUsersInOrganizationSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
         * @param {boolean} [advancedSearch] Advanced search mode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomizations(offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: ListAllUsersInOrganizationSearchParameter, searchField?: ListAllUsersInOrganizationSearchParameter, advancedSearch?: boolean, options?: any): AxiosPromise<CustomizationResultSet> {
            return localVarFp.getCustomizations(offset, limit, sortBy, sortDirection, search, searchField, advancedSearch, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a list that describes customization searchable fields
         * @summary Lists searchable fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCustomizationSearchDescription(options?: any): AxiosPromise<SearchDescription> {
            return localVarFp.listCustomizationSearchDescription(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Updates an existing customization\'s name
         * @param {string} customizationId ID of the Customization for which the name is being updated
         * @param {UpdateCustomizationLabelRequest} [updateCustomizationLabelRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCustomizationLabel(customizationId: string, updateCustomizationLabelRequest?: UpdateCustomizationLabelRequest, options?: any): AxiosPromise<CustomizationWithRedeemableInventory> {
            return localVarFp.updateCustomizationLabel(customizationId, updateCustomizationLabelRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CustomizationsApi - object-oriented interface
 * @export
 * @class CustomizationsApi
 * @extends {BaseAPI}
 */
export class CustomizationsApi extends BaseAPI {
    /**
     * Returns a list of products and quantities available for a specific customization 
     * @summary Gets a list of products and quantities available for a specific customization
     * @param {string} customizationId ID of the Customization for which the inventory is being fetched
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomizationsApi
     */
    public getCustomizationInventory(customizationId: string, options?: AxiosRequestConfig) {
        return CustomizationsApiFp(this.configuration).getCustomizationInventory(customizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get customizations
     * @param {number} [offset] Number of items to offset the list by (used for pagination)
     * @param {number} [limit] Number of items to limit the list by (used for pagination)
     * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
     * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
     * @param {ListAllUsersInOrganizationSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
     * @param {ListAllUsersInOrganizationSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
     * @param {boolean} [advancedSearch] Advanced search mode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomizationsApi
     */
    public getCustomizations(offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: ListAllUsersInOrganizationSearchParameter, searchField?: ListAllUsersInOrganizationSearchParameter, advancedSearch?: boolean, options?: AxiosRequestConfig) {
        return CustomizationsApiFp(this.configuration).getCustomizations(offset, limit, sortBy, sortDirection, search, searchField, advancedSearch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a list that describes customization searchable fields
     * @summary Lists searchable fields
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomizationsApi
     */
    public listCustomizationSearchDescription(options?: AxiosRequestConfig) {
        return CustomizationsApiFp(this.configuration).listCustomizationSearchDescription(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Updates an existing customization\'s name
     * @param {string} customizationId ID of the Customization for which the name is being updated
     * @param {UpdateCustomizationLabelRequest} [updateCustomizationLabelRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomizationsApi
     */
    public updateCustomizationLabel(customizationId: string, updateCustomizationLabelRequest?: UpdateCustomizationLabelRequest, options?: AxiosRequestConfig) {
        return CustomizationsApiFp(this.configuration).updateCustomizationLabel(customizationId, updateCustomizationLabelRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * Fido2PreRegisteredShipmentsApi - axios parameter creator
 * @export
 */
export const Fido2PreRegisteredShipmentsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Place a request for shipment of FIDO2 Pre-registered Yubikeys. This is restricted to users in the organization associated with the authentication token.
         * @summary Create a FIDO2 Pre-registered Shipment
         * @param {FPRShipmentRequest} [fPRShipmentRequest] FPRShipmentRequest to be added to the requesting user\&#39;s organization.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFPRShipment: async (fPRShipmentRequest?: FPRShipmentRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/fpr/shipments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(fPRShipmentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a FIDO2 Pre-registered shipment by its ID
         * @param {string} shipmentId ID of FIDO2 Pre-registered shipment to be deleted
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFPRShipmentById: async (shipmentId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'shipmentId' is not null or undefined
            assertParamExists('deleteFPRShipmentById', 'shipmentId', shipmentId)
            const localVarPath = `/v1/fpr/shipments/{shipmentId}`
                .replace(`{${"shipmentId"}}`, encodeURIComponent(String(shipmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a FIDO2 Pre-registered shipment by its ID
         * @param {string} shipmentId ID of FIDO2 Pre-registered shipment to be fetched
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFPRShipmentById: async (shipmentId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'shipmentId' is not null or undefined
            assertParamExists('getFPRShipmentById', 'shipmentId', shipmentId)
            const localVarPath = `/v1/fpr/shipments/{shipmentId}`
                .replace(`{${"shipmentId"}}`, encodeURIComponent(String(shipmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update recipient or address information of a FIDO2 Pre-registered shipment
         * @summary Edit a FIDO2 Pre-registered Shipment recipient address
         * @param {string} shipmentId Id of shipment
         * @param {FPRShipmentRecipientAddressRequest} [fPRShipmentRecipientAddressRequest] FPRShipmentRecipientAddressRequest to be updated in existing FIDO2 Pre-registered shipment.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFPRShipmentRecipientAddressById: async (shipmentId: string, fPRShipmentRecipientAddressRequest?: FPRShipmentRecipientAddressRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'shipmentId' is not null or undefined
            assertParamExists('updateFPRShipmentRecipientAddressById', 'shipmentId', shipmentId)
            const localVarPath = `/v1/fpr/shipments/{shipmentId}`
                .replace(`{${"shipmentId"}}`, encodeURIComponent(String(shipmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(fPRShipmentRecipientAddressRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * Fido2PreRegisteredShipmentsApi - functional programming interface
 * @export
 */
export const Fido2PreRegisteredShipmentsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = Fido2PreRegisteredShipmentsApiAxiosParamCreator(configuration)
    return {
        /**
         * Place a request for shipment of FIDO2 Pre-registered Yubikeys. This is restricted to users in the organization associated with the authentication token.
         * @summary Create a FIDO2 Pre-registered Shipment
         * @param {FPRShipmentRequest} [fPRShipmentRequest] FPRShipmentRequest to be added to the requesting user\&#39;s organization.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createFPRShipment(fPRShipmentRequest?: FPRShipmentRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FPRShipmentResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createFPRShipment(fPRShipmentRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete a FIDO2 Pre-registered shipment by its ID
         * @param {string} shipmentId ID of FIDO2 Pre-registered shipment to be deleted
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteFPRShipmentById(shipmentId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteFPRShipmentById(shipmentId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get a FIDO2 Pre-registered shipment by its ID
         * @param {string} shipmentId ID of FIDO2 Pre-registered shipment to be fetched
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFPRShipmentById(shipmentId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FPRShipmentResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFPRShipmentById(shipmentId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update recipient or address information of a FIDO2 Pre-registered shipment
         * @summary Edit a FIDO2 Pre-registered Shipment recipient address
         * @param {string} shipmentId Id of shipment
         * @param {FPRShipmentRecipientAddressRequest} [fPRShipmentRecipientAddressRequest] FPRShipmentRecipientAddressRequest to be updated in existing FIDO2 Pre-registered shipment.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateFPRShipmentRecipientAddressById(shipmentId: string, fPRShipmentRecipientAddressRequest?: FPRShipmentRecipientAddressRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FPRShipmentResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateFPRShipmentRecipientAddressById(shipmentId, fPRShipmentRecipientAddressRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * Fido2PreRegisteredShipmentsApi - factory interface
 * @export
 */
export const Fido2PreRegisteredShipmentsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = Fido2PreRegisteredShipmentsApiFp(configuration)
    return {
        /**
         * Place a request for shipment of FIDO2 Pre-registered Yubikeys. This is restricted to users in the organization associated with the authentication token.
         * @summary Create a FIDO2 Pre-registered Shipment
         * @param {FPRShipmentRequest} [fPRShipmentRequest] FPRShipmentRequest to be added to the requesting user\&#39;s organization.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFPRShipment(fPRShipmentRequest?: FPRShipmentRequest, options?: any): AxiosPromise<FPRShipmentResponse> {
            return localVarFp.createFPRShipment(fPRShipmentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a FIDO2 Pre-registered shipment by its ID
         * @param {string} shipmentId ID of FIDO2 Pre-registered shipment to be deleted
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFPRShipmentById(shipmentId: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteFPRShipmentById(shipmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a FIDO2 Pre-registered shipment by its ID
         * @param {string} shipmentId ID of FIDO2 Pre-registered shipment to be fetched
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFPRShipmentById(shipmentId: string, options?: any): AxiosPromise<FPRShipmentResponse> {
            return localVarFp.getFPRShipmentById(shipmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * Update recipient or address information of a FIDO2 Pre-registered shipment
         * @summary Edit a FIDO2 Pre-registered Shipment recipient address
         * @param {string} shipmentId Id of shipment
         * @param {FPRShipmentRecipientAddressRequest} [fPRShipmentRecipientAddressRequest] FPRShipmentRecipientAddressRequest to be updated in existing FIDO2 Pre-registered shipment.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFPRShipmentRecipientAddressById(shipmentId: string, fPRShipmentRecipientAddressRequest?: FPRShipmentRecipientAddressRequest, options?: any): AxiosPromise<FPRShipmentResponse> {
            return localVarFp.updateFPRShipmentRecipientAddressById(shipmentId, fPRShipmentRecipientAddressRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Fido2PreRegisteredShipmentsApi - object-oriented interface
 * @export
 * @class Fido2PreRegisteredShipmentsApi
 * @extends {BaseAPI}
 */
export class Fido2PreRegisteredShipmentsApi extends BaseAPI {
    /**
     * Place a request for shipment of FIDO2 Pre-registered Yubikeys. This is restricted to users in the organization associated with the authentication token.
     * @summary Create a FIDO2 Pre-registered Shipment
     * @param {FPRShipmentRequest} [fPRShipmentRequest] FPRShipmentRequest to be added to the requesting user\&#39;s organization.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Fido2PreRegisteredShipmentsApi
     */
    public createFPRShipment(fPRShipmentRequest?: FPRShipmentRequest, options?: AxiosRequestConfig) {
        return Fido2PreRegisteredShipmentsApiFp(this.configuration).createFPRShipment(fPRShipmentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a FIDO2 Pre-registered shipment by its ID
     * @param {string} shipmentId ID of FIDO2 Pre-registered shipment to be deleted
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Fido2PreRegisteredShipmentsApi
     */
    public deleteFPRShipmentById(shipmentId: string, options?: AxiosRequestConfig) {
        return Fido2PreRegisteredShipmentsApiFp(this.configuration).deleteFPRShipmentById(shipmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a FIDO2 Pre-registered shipment by its ID
     * @param {string} shipmentId ID of FIDO2 Pre-registered shipment to be fetched
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Fido2PreRegisteredShipmentsApi
     */
    public getFPRShipmentById(shipmentId: string, options?: AxiosRequestConfig) {
        return Fido2PreRegisteredShipmentsApiFp(this.configuration).getFPRShipmentById(shipmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update recipient or address information of a FIDO2 Pre-registered shipment
     * @summary Edit a FIDO2 Pre-registered Shipment recipient address
     * @param {string} shipmentId Id of shipment
     * @param {FPRShipmentRecipientAddressRequest} [fPRShipmentRecipientAddressRequest] FPRShipmentRecipientAddressRequest to be updated in existing FIDO2 Pre-registered shipment.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Fido2PreRegisteredShipmentsApi
     */
    public updateFPRShipmentRecipientAddressById(shipmentId: string, fPRShipmentRecipientAddressRequest?: FPRShipmentRecipientAddressRequest, options?: AxiosRequestConfig) {
        return Fido2PreRegisteredShipmentsApiFp(this.configuration).updateFPRShipmentRecipientAddressById(shipmentId, fPRShipmentRecipientAddressRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * InventoryApi - axios parameter creator
 * @export
 */
export const InventoryApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns an array of product SKUs and quantities for an organization whose OrganizationId corresponds to that of the token making the request.  /inventory returns all products associated with an organization’s account. Regardless of inventory type, all inventory with `amount_remaining` equal to 0 are excluded. 
         * @summary Returns array of SKUs and quantities available for the organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInventoryOfOrganizationInContext: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/inventory`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns array of product SKUs and quantities for the organization whose OrganizationId corresponds to that of the token making the request, and the channelpartnerId in the URL. Note that channelpartner is renamed to reseller, including all prefixes. The expected values for these fields remain the same.
         * @summary Returns array of SKUs and quantities available for the organization for a specific channelpartner
         * @param {number} channelpartnerId ID of the channelpartner
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInventoryWithChannelPartnerId: async (channelpartnerId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'channelpartnerId' is not null or undefined
            assertParamExists('getInventoryWithChannelPartnerId', 'channelpartnerId', channelpartnerId)
            const localVarPath = `/v1/inventory/channelpartners/{channelpartnerId}`
                .replace(`{${"channelpartnerId"}}`, encodeURIComponent(String(channelpartnerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InventoryApi - functional programming interface
 * @export
 */
export const InventoryApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = InventoryApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns an array of product SKUs and quantities for an organization whose OrganizationId corresponds to that of the token making the request.  /inventory returns all products associated with an organization’s account. Regardless of inventory type, all inventory with `amount_remaining` equal to 0 are excluded. 
         * @summary Returns array of SKUs and quantities available for the organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInventoryOfOrganizationInContext(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationProductInventorySet>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInventoryOfOrganizationInContext(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns array of product SKUs and quantities for the organization whose OrganizationId corresponds to that of the token making the request, and the channelpartnerId in the URL. Note that channelpartner is renamed to reseller, including all prefixes. The expected values for these fields remain the same.
         * @summary Returns array of SKUs and quantities available for the organization for a specific channelpartner
         * @param {number} channelpartnerId ID of the channelpartner
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInventoryWithChannelPartnerId(channelpartnerId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationProductChannelPartnerInventorySet>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInventoryWithChannelPartnerId(channelpartnerId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * InventoryApi - factory interface
 * @export
 */
export const InventoryApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = InventoryApiFp(configuration)
    return {
        /**
         * Returns an array of product SKUs and quantities for an organization whose OrganizationId corresponds to that of the token making the request.  /inventory returns all products associated with an organization’s account. Regardless of inventory type, all inventory with `amount_remaining` equal to 0 are excluded. 
         * @summary Returns array of SKUs and quantities available for the organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInventoryOfOrganizationInContext(options?: any): AxiosPromise<OrganizationProductInventorySet> {
            return localVarFp.getInventoryOfOrganizationInContext(options).then((request) => request(axios, basePath));
        },
        /**
         * Returns array of product SKUs and quantities for the organization whose OrganizationId corresponds to that of the token making the request, and the channelpartnerId in the URL. Note that channelpartner is renamed to reseller, including all prefixes. The expected values for these fields remain the same.
         * @summary Returns array of SKUs and quantities available for the organization for a specific channelpartner
         * @param {number} channelpartnerId ID of the channelpartner
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInventoryWithChannelPartnerId(channelpartnerId: number, options?: any): AxiosPromise<OrganizationProductChannelPartnerInventorySet> {
            return localVarFp.getInventoryWithChannelPartnerId(channelpartnerId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * InventoryApi - object-oriented interface
 * @export
 * @class InventoryApi
 * @extends {BaseAPI}
 */
export class InventoryApi extends BaseAPI {
    /**
     * Returns an array of product SKUs and quantities for an organization whose OrganizationId corresponds to that of the token making the request.  /inventory returns all products associated with an organization’s account. Regardless of inventory type, all inventory with `amount_remaining` equal to 0 are excluded. 
     * @summary Returns array of SKUs and quantities available for the organization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InventoryApi
     */
    public getInventoryOfOrganizationInContext(options?: AxiosRequestConfig) {
        return InventoryApiFp(this.configuration).getInventoryOfOrganizationInContext(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns array of product SKUs and quantities for the organization whose OrganizationId corresponds to that of the token making the request, and the channelpartnerId in the URL. Note that channelpartner is renamed to reseller, including all prefixes. The expected values for these fields remain the same.
     * @summary Returns array of SKUs and quantities available for the organization for a specific channelpartner
     * @param {number} channelpartnerId ID of the channelpartner
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InventoryApi
     */
    public getInventoryWithChannelPartnerId(channelpartnerId: number, options?: AxiosRequestConfig) {
        return InventoryApiFp(this.configuration).getInventoryWithChannelPartnerId(channelpartnerId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * InventoryAllocationsApi - axios parameter creator
 * @export
 */
export const InventoryAllocationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get inventory allocations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInventoryAllocations: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/inventory-allocations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InventoryAllocationsApi - functional programming interface
 * @export
 */
export const InventoryAllocationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = InventoryAllocationsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get inventory allocations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInventoryAllocations(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InventoryAllocationCollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInventoryAllocations(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * InventoryAllocationsApi - factory interface
 * @export
 */
export const InventoryAllocationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = InventoryAllocationsApiFp(configuration)
    return {
        /**
         * 
         * @summary Get inventory allocations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInventoryAllocations(options?: any): AxiosPromise<InventoryAllocationCollectionResponse> {
            return localVarFp.getInventoryAllocations(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * InventoryAllocationsApi - object-oriented interface
 * @export
 * @class InventoryAllocationsApi
 * @extends {BaseAPI}
 */
export class InventoryAllocationsApi extends BaseAPI {
    /**
     * 
     * @summary Get inventory allocations
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InventoryAllocationsApi
     */
    public getInventoryAllocations(options?: AxiosRequestConfig) {
        return InventoryAllocationsApiFp(this.configuration).getInventoryAllocations(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * OrganizationsApi - axios parameter creator
 * @export
 */
export const OrganizationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get the organization for authenticated user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentOrganization: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/organization`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sends a sample email for the current organization and selected template using the provided custom text. Does not update the stored custom text.
         * @summary Send a sample email with given custom text
         * @param {EmailTemplateId} template Email template to use
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        sendSampleEmail: async (template: EmailTemplateId, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'template' is not null or undefined
            assertParamExists('sendSampleEmail', 'template', template)
            const localVarPath = `/v1/organization/send-sample-email/{template}`
                .replace(`{${"template"}}`, encodeURIComponent(String(template)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrganizationsApi - functional programming interface
 * @export
 */
export const OrganizationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OrganizationsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get the organization for authenticated user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCurrentOrganization(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Organization>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCurrentOrganization(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Sends a sample email for the current organization and selected template using the provided custom text. Does not update the stored custom text.
         * @summary Send a sample email with given custom text
         * @param {EmailTemplateId} template Email template to use
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async sendSampleEmail(template: EmailTemplateId, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendSampleEmail(template, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * OrganizationsApi - factory interface
 * @export
 */
export const OrganizationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OrganizationsApiFp(configuration)
    return {
        /**
         * 
         * @summary Get the organization for authenticated user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentOrganization(options?: any): AxiosPromise<Organization> {
            return localVarFp.getCurrentOrganization(options).then((request) => request(axios, basePath));
        },
        /**
         * Sends a sample email for the current organization and selected template using the provided custom text. Does not update the stored custom text.
         * @summary Send a sample email with given custom text
         * @param {EmailTemplateId} template Email template to use
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        sendSampleEmail(template: EmailTemplateId, options?: any): AxiosPromise<void> {
            return localVarFp.sendSampleEmail(template, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OrganizationsApi - object-oriented interface
 * @export
 * @class OrganizationsApi
 * @extends {BaseAPI}
 */
export class OrganizationsApi extends BaseAPI {
    /**
     * 
     * @summary Get the organization for authenticated user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public getCurrentOrganization(options?: AxiosRequestConfig) {
        return OrganizationsApiFp(this.configuration).getCurrentOrganization(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sends a sample email for the current organization and selected template using the provided custom text. Does not update the stored custom text.
     * @summary Send a sample email with given custom text
     * @param {EmailTemplateId} template Email template to use
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public sendSampleEmail(template: EmailTemplateId, options?: AxiosRequestConfig) {
        return OrganizationsApiFp(this.configuration).sendSampleEmail(template, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ProductsApi - axios parameter creator
 * @export
 */
export const ProductsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get a product by its ID
         * @param {number} productId ID of product to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductById: async (productId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('getProductById', 'productId', productId)
            const localVarPath = `/v1/products/{productId}`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns list of all products
         * @summary List products
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProducts: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/products`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProductsApi - functional programming interface
 * @export
 */
export const ProductsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProductsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get a product by its ID
         * @param {number} productId ID of product to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductById(productId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Product>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductById(productId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns list of all products
         * @summary List products
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProducts(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductResultSet>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProducts(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ProductsApi - factory interface
 * @export
 */
export const ProductsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProductsApiFp(configuration)
    return {
        /**
         * 
         * @summary Get a product by its ID
         * @param {number} productId ID of product to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductById(productId: number, options?: any): AxiosPromise<Product> {
            return localVarFp.getProductById(productId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns list of all products
         * @summary List products
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProducts(options?: any): AxiosPromise<ProductResultSet> {
            return localVarFp.getProducts(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProductsApi - object-oriented interface
 * @export
 * @class ProductsApi
 * @extends {BaseAPI}
 */
export class ProductsApi extends BaseAPI {
    /**
     * 
     * @summary Get a product by its ID
     * @param {number} productId ID of product to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public getProductById(productId: number, options?: AxiosRequestConfig) {
        return ProductsApiFp(this.configuration).getProductById(productId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns list of all products
     * @summary List products
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public getProducts(options?: AxiosRequestConfig) {
        return ProductsApiFp(this.configuration).getProducts(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * PurchaseOrdersApi - axios parameter creator
 * @export
 */
export const PurchaseOrdersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Please note, channelpartner has been renamed reseller, including all prefixes. The expected values for these fields remains the same.
         * @summary Get a purchase order by its ID
         * @param {string} purchaseorderId ID of purchase order that needs to be fetched
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPurchaseOrderById: async (purchaseorderId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'purchaseorderId' is not null or undefined
            assertParamExists('getPurchaseOrderById', 'purchaseorderId', purchaseorderId)
            const localVarPath = `/v1/purchaseorders/{purchaseorderId}`
                .replace(`{${"purchaseorderId"}}`, encodeURIComponent(String(purchaseorderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Please note, channelpartner has been renamed reseller, including all prefixes. The expected values for these fields remains the same.
         * @summary List the purchase orders of the current organization
         * @param {number} [offset] Number of items to offset the list by (used for pagination)
         * @param {number} [limit] Number of items to limit the list by (used for pagination)
         * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
         * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
         * @param {ListAllUsersInOrganizationSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
         * @param {ListAllUsersInOrganizationSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
         * @param {boolean} [advancedSearch] Advanced search mode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPurchaseOrdersOfOrganization: async (offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: ListAllUsersInOrganizationSearchParameter, searchField?: ListAllUsersInOrganizationSearchParameter, advancedSearch?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/purchaseorders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "authorization", configuration)

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sort_direction'] = sortDirection;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (searchField !== undefined) {
                localVarQueryParameter['search_field'] = searchField;
            }

            if (advancedSearch !== undefined) {
                localVarQueryParameter['advanced_search'] = advancedSearch;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a list that describes purchaseorders searchable fields
         * @summary Lists searchable fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPurchaseOrdersSearchDescription: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/purchaseorders/search-description`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PurchaseOrdersApi - functional programming interface
 * @export
 */
export const PurchaseOrdersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PurchaseOrdersApiAxiosParamCreator(configuration)
    return {
        /**
         * Please note, channelpartner has been renamed reseller, including all prefixes. The expected values for these fields remains the same.
         * @summary Get a purchase order by its ID
         * @param {string} purchaseorderId ID of purchase order that needs to be fetched
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPurchaseOrderById(purchaseorderId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomerPurchaseOrderResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPurchaseOrderById(purchaseorderId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Please note, channelpartner has been renamed reseller, including all prefixes. The expected values for these fields remains the same.
         * @summary List the purchase orders of the current organization
         * @param {number} [offset] Number of items to offset the list by (used for pagination)
         * @param {number} [limit] Number of items to limit the list by (used for pagination)
         * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
         * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
         * @param {ListAllUsersInOrganizationSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
         * @param {ListAllUsersInOrganizationSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
         * @param {boolean} [advancedSearch] Advanced search mode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPurchaseOrdersOfOrganization(offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: ListAllUsersInOrganizationSearchParameter, searchField?: ListAllUsersInOrganizationSearchParameter, advancedSearch?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomerPurchaseOrderResponseSet>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPurchaseOrdersOfOrganization(offset, limit, sortBy, sortDirection, search, searchField, advancedSearch, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns a list that describes purchaseorders searchable fields
         * @summary Lists searchable fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listPurchaseOrdersSearchDescription(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchDescription>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listPurchaseOrdersSearchDescription(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PurchaseOrdersApi - factory interface
 * @export
 */
export const PurchaseOrdersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PurchaseOrdersApiFp(configuration)
    return {
        /**
         * Please note, channelpartner has been renamed reseller, including all prefixes. The expected values for these fields remains the same.
         * @summary Get a purchase order by its ID
         * @param {string} purchaseorderId ID of purchase order that needs to be fetched
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPurchaseOrderById(purchaseorderId: string, options?: any): AxiosPromise<CustomerPurchaseOrderResponse> {
            return localVarFp.getPurchaseOrderById(purchaseorderId, options).then((request) => request(axios, basePath));
        },
        /**
         * Please note, channelpartner has been renamed reseller, including all prefixes. The expected values for these fields remains the same.
         * @summary List the purchase orders of the current organization
         * @param {number} [offset] Number of items to offset the list by (used for pagination)
         * @param {number} [limit] Number of items to limit the list by (used for pagination)
         * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
         * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
         * @param {ListAllUsersInOrganizationSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
         * @param {ListAllUsersInOrganizationSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
         * @param {boolean} [advancedSearch] Advanced search mode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPurchaseOrdersOfOrganization(offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: ListAllUsersInOrganizationSearchParameter, searchField?: ListAllUsersInOrganizationSearchParameter, advancedSearch?: boolean, options?: any): AxiosPromise<CustomerPurchaseOrderResponseSet> {
            return localVarFp.getPurchaseOrdersOfOrganization(offset, limit, sortBy, sortDirection, search, searchField, advancedSearch, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a list that describes purchaseorders searchable fields
         * @summary Lists searchable fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPurchaseOrdersSearchDescription(options?: any): AxiosPromise<SearchDescription> {
            return localVarFp.listPurchaseOrdersSearchDescription(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PurchaseOrdersApi - object-oriented interface
 * @export
 * @class PurchaseOrdersApi
 * @extends {BaseAPI}
 */
export class PurchaseOrdersApi extends BaseAPI {
    /**
     * Please note, channelpartner has been renamed reseller, including all prefixes. The expected values for these fields remains the same.
     * @summary Get a purchase order by its ID
     * @param {string} purchaseorderId ID of purchase order that needs to be fetched
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PurchaseOrdersApi
     */
    public getPurchaseOrderById(purchaseorderId: string, options?: AxiosRequestConfig) {
        return PurchaseOrdersApiFp(this.configuration).getPurchaseOrderById(purchaseorderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Please note, channelpartner has been renamed reseller, including all prefixes. The expected values for these fields remains the same.
     * @summary List the purchase orders of the current organization
     * @param {number} [offset] Number of items to offset the list by (used for pagination)
     * @param {number} [limit] Number of items to limit the list by (used for pagination)
     * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
     * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
     * @param {ListAllUsersInOrganizationSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
     * @param {ListAllUsersInOrganizationSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
     * @param {boolean} [advancedSearch] Advanced search mode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PurchaseOrdersApi
     */
    public getPurchaseOrdersOfOrganization(offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: ListAllUsersInOrganizationSearchParameter, searchField?: ListAllUsersInOrganizationSearchParameter, advancedSearch?: boolean, options?: AxiosRequestConfig) {
        return PurchaseOrdersApiFp(this.configuration).getPurchaseOrdersOfOrganization(offset, limit, sortBy, sortDirection, search, searchField, advancedSearch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a list that describes purchaseorders searchable fields
     * @summary Lists searchable fields
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PurchaseOrdersApi
     */
    public listPurchaseOrdersSearchDescription(options?: AxiosRequestConfig) {
        return PurchaseOrdersApiFp(this.configuration).listPurchaseOrdersSearchDescription(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * RefundsApi - axios parameter creator
 * @export
 */
export const RefundsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Download a CSV of all shipment refunds for an organization
         * @param {number} [limit] Number of items to limit the list by (used for pagination)
         * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
         * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
         * @param {ListAllUsersInOrganizationSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
         * @param {ListAllUsersInOrganizationSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
         * @param {boolean} [advancedSearch] Advanced search mode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadRefunds: async (limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: ListAllUsersInOrganizationSearchParameter, searchField?: ListAllUsersInOrganizationSearchParameter, advancedSearch?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/refunds/csv`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "authorization", configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sort_direction'] = sortDirection;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (searchField !== undefined) {
                localVarQueryParameter['search_field'] = searchField;
            }

            if (advancedSearch !== undefined) {
                localVarQueryParameter['advanced_search'] = advancedSearch;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all shipping and product refunds for an organization
         * @summary Get organization refund information
         * @param {number} [offset] Number of items to offset the list by (used for pagination)
         * @param {number} [limit] Number of items to limit the list by (used for pagination)
         * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
         * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
         * @param {ListAllUsersInOrganizationSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
         * @param {ListAllUsersInOrganizationSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
         * @param {boolean} [advancedSearch] Advanced search mode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllShipmentRefunds: async (offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: ListAllUsersInOrganizationSearchParameter, searchField?: ListAllUsersInOrganizationSearchParameter, advancedSearch?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/refunds`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "authorization", configuration)

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sort_direction'] = sortDirection;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (searchField !== undefined) {
                localVarQueryParameter['search_field'] = searchField;
            }

            if (advancedSearch !== undefined) {
                localVarQueryParameter['advanced_search'] = advancedSearch;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a list that describes shipment refunds searchable fields
         * @summary Lists searchable fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShipmentRefundSearchDescription: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/refunds/search-description`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RefundsApi - functional programming interface
 * @export
 */
export const RefundsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RefundsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Download a CSV of all shipment refunds for an organization
         * @param {number} [limit] Number of items to limit the list by (used for pagination)
         * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
         * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
         * @param {ListAllUsersInOrganizationSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
         * @param {ListAllUsersInOrganizationSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
         * @param {boolean} [advancedSearch] Advanced search mode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadRefunds(limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: ListAllUsersInOrganizationSearchParameter, searchField?: ListAllUsersInOrganizationSearchParameter, advancedSearch?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadRefunds(limit, sortBy, sortDirection, search, searchField, advancedSearch, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get all shipping and product refunds for an organization
         * @summary Get organization refund information
         * @param {number} [offset] Number of items to offset the list by (used for pagination)
         * @param {number} [limit] Number of items to limit the list by (used for pagination)
         * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
         * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
         * @param {ListAllUsersInOrganizationSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
         * @param {ListAllUsersInOrganizationSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
         * @param {boolean} [advancedSearch] Advanced search mode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllShipmentRefunds(offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: ListAllUsersInOrganizationSearchParameter, searchField?: ListAllUsersInOrganizationSearchParameter, advancedSearch?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RefundResultSet>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllShipmentRefunds(offset, limit, sortBy, sortDirection, search, searchField, advancedSearch, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns a list that describes shipment refunds searchable fields
         * @summary Lists searchable fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getShipmentRefundSearchDescription(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchDescription>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getShipmentRefundSearchDescription(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * RefundsApi - factory interface
 * @export
 */
export const RefundsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RefundsApiFp(configuration)
    return {
        /**
         * 
         * @summary Download a CSV of all shipment refunds for an organization
         * @param {number} [limit] Number of items to limit the list by (used for pagination)
         * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
         * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
         * @param {ListAllUsersInOrganizationSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
         * @param {ListAllUsersInOrganizationSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
         * @param {boolean} [advancedSearch] Advanced search mode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadRefunds(limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: ListAllUsersInOrganizationSearchParameter, searchField?: ListAllUsersInOrganizationSearchParameter, advancedSearch?: boolean, options?: any): AxiosPromise<string> {
            return localVarFp.downloadRefunds(limit, sortBy, sortDirection, search, searchField, advancedSearch, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all shipping and product refunds for an organization
         * @summary Get organization refund information
         * @param {number} [offset] Number of items to offset the list by (used for pagination)
         * @param {number} [limit] Number of items to limit the list by (used for pagination)
         * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
         * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
         * @param {ListAllUsersInOrganizationSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
         * @param {ListAllUsersInOrganizationSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
         * @param {boolean} [advancedSearch] Advanced search mode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllShipmentRefunds(offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: ListAllUsersInOrganizationSearchParameter, searchField?: ListAllUsersInOrganizationSearchParameter, advancedSearch?: boolean, options?: any): AxiosPromise<RefundResultSet> {
            return localVarFp.getAllShipmentRefunds(offset, limit, sortBy, sortDirection, search, searchField, advancedSearch, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a list that describes shipment refunds searchable fields
         * @summary Lists searchable fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShipmentRefundSearchDescription(options?: any): AxiosPromise<SearchDescription> {
            return localVarFp.getShipmentRefundSearchDescription(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RefundsApi - object-oriented interface
 * @export
 * @class RefundsApi
 * @extends {BaseAPI}
 */
export class RefundsApi extends BaseAPI {
    /**
     * 
     * @summary Download a CSV of all shipment refunds for an organization
     * @param {number} [limit] Number of items to limit the list by (used for pagination)
     * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
     * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
     * @param {ListAllUsersInOrganizationSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
     * @param {ListAllUsersInOrganizationSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
     * @param {boolean} [advancedSearch] Advanced search mode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RefundsApi
     */
    public downloadRefunds(limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: ListAllUsersInOrganizationSearchParameter, searchField?: ListAllUsersInOrganizationSearchParameter, advancedSearch?: boolean, options?: AxiosRequestConfig) {
        return RefundsApiFp(this.configuration).downloadRefunds(limit, sortBy, sortDirection, search, searchField, advancedSearch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all shipping and product refunds for an organization
     * @summary Get organization refund information
     * @param {number} [offset] Number of items to offset the list by (used for pagination)
     * @param {number} [limit] Number of items to limit the list by (used for pagination)
     * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
     * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
     * @param {ListAllUsersInOrganizationSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
     * @param {ListAllUsersInOrganizationSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
     * @param {boolean} [advancedSearch] Advanced search mode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RefundsApi
     */
    public getAllShipmentRefunds(offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: ListAllUsersInOrganizationSearchParameter, searchField?: ListAllUsersInOrganizationSearchParameter, advancedSearch?: boolean, options?: AxiosRequestConfig) {
        return RefundsApiFp(this.configuration).getAllShipmentRefunds(offset, limit, sortBy, sortDirection, search, searchField, advancedSearch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a list that describes shipment refunds searchable fields
     * @summary Lists searchable fields
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RefundsApi
     */
    public getShipmentRefundSearchDescription(options?: AxiosRequestConfig) {
        return RefundsApiFp(this.configuration).getShipmentRefundSearchDescription(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ShipmentsApi - axios parameter creator
 * @export
 */
export const ShipmentsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Override a shipment in state \"invalid address\" or \"address fail\", thus confirming that the address is valid.
         * @summary Override invalid address
         * @param {string} shipmentId Id of shipment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addressOverride: async (shipmentId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'shipmentId' is not null or undefined
            assertParamExists('addressOverride', 'shipmentId', shipmentId)
            const localVarPath = `/v1/shipments_exact/{shipmentId}/address-override`
                .replace(`{${"shipmentId"}}`, encodeURIComponent(String(shipmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Override multiple shipments in state \"invalid address\" or \"address fail\", thus confirming that the addresses are valid.
         * @summary Override invalid address of multiple shipments
         * @param {Array<string>} [requestBody] A non-empty JSON list of shipment Ids to override
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkAddressOverride: async (requestBody?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/shipments/address-override`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Place a request for a shipment. This is restricted to users in the organization associated with the authentication token. Note that channelpartner is renamed to reseller, including all prefixes. The expected values for these fields remain the same.
         * @summary Create a new shipment
         * @param {ShipmentExactRequest} [body] ShipmentRequest to be added to the requesting user\&#39;s organization.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createShipmentExact: async (body?: ShipmentExactRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/shipments_exact`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Place a request for bulk deletion of shipments
         * @param {Array<string>} [requestBody] A JSON list of shipment Ids to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBulkShipment: async (requestBody?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/shipments/bulkdelete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a shipment by its ID
         * @param {string} shipmentId ID of the shipment to be deleted
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteShipmentExactById: async (shipmentId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'shipmentId' is not null or undefined
            assertParamExists('deleteShipmentExactById', 'shipmentId', shipmentId)
            const localVarPath = `/v1/shipments_exact/{shipmentId}`
                .replace(`{${"shipmentId"}}`, encodeURIComponent(String(shipmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Download a CSV with shipments
         * @param {number} [limit] Number of items to limit the list by (used for pagination)
         * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
         * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
         * @param {ListAllUsersInOrganizationSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
         * @param {ListAllUsersInOrganizationSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
         * @param {boolean} [advancedSearch] Advanced search mode
         * @param {ListAllUsersInOrganizationSearchParameter} [excludedCols] Column names to be excluded from the downloaded CSV file.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadShipments: async (limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: ListAllUsersInOrganizationSearchParameter, searchField?: ListAllUsersInOrganizationSearchParameter, advancedSearch?: boolean, excludedCols?: ListAllUsersInOrganizationSearchParameter, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/shipments/csv`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "authorization", configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sort_direction'] = sortDirection;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (searchField !== undefined) {
                localVarQueryParameter['search_field'] = searchField;
            }

            if (advancedSearch !== undefined) {
                localVarQueryParameter['advanced_search'] = advancedSearch;
            }

            if (excludedCols !== undefined) {
                localVarQueryParameter['excluded_cols'] = excludedCols;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Note that channelpartner is renamed to reseller, including all prefixes. The expected values for these fields remain the same.
         * @summary Get a shipment by its ID
         * @param {string} shipmentId ID of shipment to be fetched
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShipmentExactById: async (shipmentId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'shipmentId' is not null or undefined
            assertParamExists('getShipmentExactById', 'shipmentId', shipmentId)
            const localVarPath = `/v1/shipments_exact/{shipmentId}`
                .replace(`{${"shipmentId"}}`, encodeURIComponent(String(shipmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all shipping and product refund information for a shipment
         * @summary Get refund information for a shipment
         * @param {string} shipmentId Id of shipment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShipmentRefunds: async (shipmentId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'shipmentId' is not null or undefined
            assertParamExists('getShipmentRefunds', 'shipmentId', shipmentId)
            const localVarPath = `/v1/shipments_exact/{shipmentId}/refunds`
                .replace(`{${"shipmentId"}}`, encodeURIComponent(String(shipmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns an array of shipment objects with IDs.  Returns all shipments a user has permission to view, including shipments to other recipients.   Because there is a 100-record limit on all API calls only the first 100 records are returned.  If there are more than 100 shipments, iterate through the shipments based on the number of shipments provided by the total_count parameter.  Use the optional offset parameter to obtain more records.  The response from the shipments_exact resource will include a shipment_id which can be used to get the tracking information for the shipment request.  Note that channelpartner is renamed to reseller, including all prefixes. The expected values for these fields remain the same. 
         * @summary List all shipments
         * @param {number} [offset] Number of items to offset the list by (used for pagination)
         * @param {number} [limit] Number of items to limit the list by (used for pagination)
         * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
         * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
         * @param {ListAllUsersInOrganizationSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
         * @param {ListAllUsersInOrganizationSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
         * @param {boolean} [advancedSearch] Advanced search mode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShipmentsExact: async (offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: ListAllUsersInOrganizationSearchParameter, searchField?: ListAllUsersInOrganizationSearchParameter, advancedSearch?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/shipments_exact`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "authorization", configuration)

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sort_direction'] = sortDirection;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (searchField !== undefined) {
                localVarQueryParameter['search_field'] = searchField;
            }

            if (advancedSearch !== undefined) {
                localVarQueryParameter['advanced_search'] = advancedSearch;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Provides a description of the searchable fields on searchable resources. Returns a metadata object that describes which fields on `GET /shipments_exact` are searchable/sortable.  To enable *advanced search*, add the query string parameter \'&advanced_search=true\'. The \'&search\' query parameters must follow the structure \'search=field_name::operation_type::value\'. 
         * @summary Lists searchable fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listShipmenExactSearchDescription: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/shipments_exact/search-description`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Depending on its state, a shipment request can be edited. The states are reflected in the messages displayed in the Console, see [Shipment Status Codes](https://docs.yubico.com/cloud-services/yubienterprise/delivery/api-best-practices-faq.html#shipment-status-codes). Note that channelpartner is renamed to reseller, including all prefixes. The expected values for these fields remain the same.
         * @summary Update a shipment by its ID
         * @param {string} shipmentId ID of shipment to be fetched
         * @param {ShipmentExactRequest} [shipmentExactRequest] add complete record of the shipment to be updated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateShipmentExactById: async (shipmentId: string, shipmentExactRequest?: ShipmentExactRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'shipmentId' is not null or undefined
            assertParamExists('updateShipmentExactById', 'shipmentId', shipmentId)
            const localVarPath = `/v1/shipments_exact/{shipmentId}`
                .replace(`{${"shipmentId"}}`, encodeURIComponent(String(shipmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(shipmentExactRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ShipmentsApi - functional programming interface
 * @export
 */
export const ShipmentsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ShipmentsApiAxiosParamCreator(configuration)
    return {
        /**
         * Override a shipment in state \"invalid address\" or \"address fail\", thus confirming that the address is valid.
         * @summary Override invalid address
         * @param {string} shipmentId Id of shipment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addressOverride(shipmentId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShipmentExactResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addressOverride(shipmentId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Override multiple shipments in state \"invalid address\" or \"address fail\", thus confirming that the addresses are valid.
         * @summary Override invalid address of multiple shipments
         * @param {Array<string>} [requestBody] A non-empty JSON list of shipment Ids to override
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkAddressOverride(requestBody?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShipmentAddressBulkOverrideResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkAddressOverride(requestBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Place a request for a shipment. This is restricted to users in the organization associated with the authentication token. Note that channelpartner is renamed to reseller, including all prefixes. The expected values for these fields remain the same.
         * @summary Create a new shipment
         * @param {ShipmentExactRequest} [body] ShipmentRequest to be added to the requesting user\&#39;s organization.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createShipmentExact(body?: ShipmentExactRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShipmentExactResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createShipmentExact(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Place a request for bulk deletion of shipments
         * @param {Array<string>} [requestBody] A JSON list of shipment Ids to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteBulkShipment(requestBody?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShipmentBulkDeleteResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteBulkShipment(requestBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete a shipment by its ID
         * @param {string} shipmentId ID of the shipment to be deleted
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteShipmentExactById(shipmentId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteShipmentExactById(shipmentId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Download a CSV with shipments
         * @param {number} [limit] Number of items to limit the list by (used for pagination)
         * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
         * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
         * @param {ListAllUsersInOrganizationSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
         * @param {ListAllUsersInOrganizationSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
         * @param {boolean} [advancedSearch] Advanced search mode
         * @param {ListAllUsersInOrganizationSearchParameter} [excludedCols] Column names to be excluded from the downloaded CSV file.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadShipments(limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: ListAllUsersInOrganizationSearchParameter, searchField?: ListAllUsersInOrganizationSearchParameter, advancedSearch?: boolean, excludedCols?: ListAllUsersInOrganizationSearchParameter, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadShipments(limit, sortBy, sortDirection, search, searchField, advancedSearch, excludedCols, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Note that channelpartner is renamed to reseller, including all prefixes. The expected values for these fields remain the same.
         * @summary Get a shipment by its ID
         * @param {string} shipmentId ID of shipment to be fetched
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getShipmentExactById(shipmentId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShipmentExactResponseWithData>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getShipmentExactById(shipmentId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get all shipping and product refund information for a shipment
         * @summary Get refund information for a shipment
         * @param {string} shipmentId Id of shipment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getShipmentRefunds(shipmentId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShipmentRefundResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getShipmentRefunds(shipmentId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns an array of shipment objects with IDs.  Returns all shipments a user has permission to view, including shipments to other recipients.   Because there is a 100-record limit on all API calls only the first 100 records are returned.  If there are more than 100 shipments, iterate through the shipments based on the number of shipments provided by the total_count parameter.  Use the optional offset parameter to obtain more records.  The response from the shipments_exact resource will include a shipment_id which can be used to get the tracking information for the shipment request.  Note that channelpartner is renamed to reseller, including all prefixes. The expected values for these fields remain the same. 
         * @summary List all shipments
         * @param {number} [offset] Number of items to offset the list by (used for pagination)
         * @param {number} [limit] Number of items to limit the list by (used for pagination)
         * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
         * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
         * @param {ListAllUsersInOrganizationSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
         * @param {ListAllUsersInOrganizationSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
         * @param {boolean} [advancedSearch] Advanced search mode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getShipmentsExact(offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: ListAllUsersInOrganizationSearchParameter, searchField?: ListAllUsersInOrganizationSearchParameter, advancedSearch?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShipmentExactResultSet>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getShipmentsExact(offset, limit, sortBy, sortDirection, search, searchField, advancedSearch, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Provides a description of the searchable fields on searchable resources. Returns a metadata object that describes which fields on `GET /shipments_exact` are searchable/sortable.  To enable *advanced search*, add the query string parameter \'&advanced_search=true\'. The \'&search\' query parameters must follow the structure \'search=field_name::operation_type::value\'. 
         * @summary Lists searchable fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listShipmenExactSearchDescription(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchDescription>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listShipmenExactSearchDescription(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Depending on its state, a shipment request can be edited. The states are reflected in the messages displayed in the Console, see [Shipment Status Codes](https://docs.yubico.com/cloud-services/yubienterprise/delivery/api-best-practices-faq.html#shipment-status-codes). Note that channelpartner is renamed to reseller, including all prefixes. The expected values for these fields remain the same.
         * @summary Update a shipment by its ID
         * @param {string} shipmentId ID of shipment to be fetched
         * @param {ShipmentExactRequest} [shipmentExactRequest] add complete record of the shipment to be updated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateShipmentExactById(shipmentId: string, shipmentExactRequest?: ShipmentExactRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShipmentExactResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateShipmentExactById(shipmentId, shipmentExactRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ShipmentsApi - factory interface
 * @export
 */
export const ShipmentsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ShipmentsApiFp(configuration)
    return {
        /**
         * Override a shipment in state \"invalid address\" or \"address fail\", thus confirming that the address is valid.
         * @summary Override invalid address
         * @param {string} shipmentId Id of shipment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addressOverride(shipmentId: string, options?: any): AxiosPromise<ShipmentExactResponse> {
            return localVarFp.addressOverride(shipmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * Override multiple shipments in state \"invalid address\" or \"address fail\", thus confirming that the addresses are valid.
         * @summary Override invalid address of multiple shipments
         * @param {Array<string>} [requestBody] A non-empty JSON list of shipment Ids to override
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkAddressOverride(requestBody?: Array<string>, options?: any): AxiosPromise<ShipmentAddressBulkOverrideResponse> {
            return localVarFp.bulkAddressOverride(requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Place a request for a shipment. This is restricted to users in the organization associated with the authentication token. Note that channelpartner is renamed to reseller, including all prefixes. The expected values for these fields remain the same.
         * @summary Create a new shipment
         * @param {ShipmentExactRequest} [body] ShipmentRequest to be added to the requesting user\&#39;s organization.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createShipmentExact(body?: ShipmentExactRequest, options?: any): AxiosPromise<ShipmentExactResponse> {
            return localVarFp.createShipmentExact(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Place a request for bulk deletion of shipments
         * @param {Array<string>} [requestBody] A JSON list of shipment Ids to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBulkShipment(requestBody?: Array<string>, options?: any): AxiosPromise<ShipmentBulkDeleteResponse> {
            return localVarFp.deleteBulkShipment(requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a shipment by its ID
         * @param {string} shipmentId ID of the shipment to be deleted
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteShipmentExactById(shipmentId: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteShipmentExactById(shipmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Download a CSV with shipments
         * @param {number} [limit] Number of items to limit the list by (used for pagination)
         * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
         * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
         * @param {ListAllUsersInOrganizationSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
         * @param {ListAllUsersInOrganizationSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
         * @param {boolean} [advancedSearch] Advanced search mode
         * @param {ListAllUsersInOrganizationSearchParameter} [excludedCols] Column names to be excluded from the downloaded CSV file.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadShipments(limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: ListAllUsersInOrganizationSearchParameter, searchField?: ListAllUsersInOrganizationSearchParameter, advancedSearch?: boolean, excludedCols?: ListAllUsersInOrganizationSearchParameter, options?: any): AxiosPromise<string> {
            return localVarFp.downloadShipments(limit, sortBy, sortDirection, search, searchField, advancedSearch, excludedCols, options).then((request) => request(axios, basePath));
        },
        /**
         * Note that channelpartner is renamed to reseller, including all prefixes. The expected values for these fields remain the same.
         * @summary Get a shipment by its ID
         * @param {string} shipmentId ID of shipment to be fetched
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShipmentExactById(shipmentId: string, options?: any): AxiosPromise<ShipmentExactResponseWithData> {
            return localVarFp.getShipmentExactById(shipmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all shipping and product refund information for a shipment
         * @summary Get refund information for a shipment
         * @param {string} shipmentId Id of shipment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShipmentRefunds(shipmentId: string, options?: any): AxiosPromise<ShipmentRefundResponse> {
            return localVarFp.getShipmentRefunds(shipmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns an array of shipment objects with IDs.  Returns all shipments a user has permission to view, including shipments to other recipients.   Because there is a 100-record limit on all API calls only the first 100 records are returned.  If there are more than 100 shipments, iterate through the shipments based on the number of shipments provided by the total_count parameter.  Use the optional offset parameter to obtain more records.  The response from the shipments_exact resource will include a shipment_id which can be used to get the tracking information for the shipment request.  Note that channelpartner is renamed to reseller, including all prefixes. The expected values for these fields remain the same. 
         * @summary List all shipments
         * @param {number} [offset] Number of items to offset the list by (used for pagination)
         * @param {number} [limit] Number of items to limit the list by (used for pagination)
         * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
         * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
         * @param {ListAllUsersInOrganizationSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
         * @param {ListAllUsersInOrganizationSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
         * @param {boolean} [advancedSearch] Advanced search mode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShipmentsExact(offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: ListAllUsersInOrganizationSearchParameter, searchField?: ListAllUsersInOrganizationSearchParameter, advancedSearch?: boolean, options?: any): AxiosPromise<ShipmentExactResultSet> {
            return localVarFp.getShipmentsExact(offset, limit, sortBy, sortDirection, search, searchField, advancedSearch, options).then((request) => request(axios, basePath));
        },
        /**
         * Provides a description of the searchable fields on searchable resources. Returns a metadata object that describes which fields on `GET /shipments_exact` are searchable/sortable.  To enable *advanced search*, add the query string parameter \'&advanced_search=true\'. The \'&search\' query parameters must follow the structure \'search=field_name::operation_type::value\'. 
         * @summary Lists searchable fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listShipmenExactSearchDescription(options?: any): AxiosPromise<SearchDescription> {
            return localVarFp.listShipmenExactSearchDescription(options).then((request) => request(axios, basePath));
        },
        /**
         * Depending on its state, a shipment request can be edited. The states are reflected in the messages displayed in the Console, see [Shipment Status Codes](https://docs.yubico.com/cloud-services/yubienterprise/delivery/api-best-practices-faq.html#shipment-status-codes). Note that channelpartner is renamed to reseller, including all prefixes. The expected values for these fields remain the same.
         * @summary Update a shipment by its ID
         * @param {string} shipmentId ID of shipment to be fetched
         * @param {ShipmentExactRequest} [shipmentExactRequest] add complete record of the shipment to be updated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateShipmentExactById(shipmentId: string, shipmentExactRequest?: ShipmentExactRequest, options?: any): AxiosPromise<ShipmentExactResponse> {
            return localVarFp.updateShipmentExactById(shipmentId, shipmentExactRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ShipmentsApi - object-oriented interface
 * @export
 * @class ShipmentsApi
 * @extends {BaseAPI}
 */
export class ShipmentsApi extends BaseAPI {
    /**
     * Override a shipment in state \"invalid address\" or \"address fail\", thus confirming that the address is valid.
     * @summary Override invalid address
     * @param {string} shipmentId Id of shipment
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    public addressOverride(shipmentId: string, options?: AxiosRequestConfig) {
        return ShipmentsApiFp(this.configuration).addressOverride(shipmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Override multiple shipments in state \"invalid address\" or \"address fail\", thus confirming that the addresses are valid.
     * @summary Override invalid address of multiple shipments
     * @param {Array<string>} [requestBody] A non-empty JSON list of shipment Ids to override
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    public bulkAddressOverride(requestBody?: Array<string>, options?: AxiosRequestConfig) {
        return ShipmentsApiFp(this.configuration).bulkAddressOverride(requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Place a request for a shipment. This is restricted to users in the organization associated with the authentication token. Note that channelpartner is renamed to reseller, including all prefixes. The expected values for these fields remain the same.
     * @summary Create a new shipment
     * @param {ShipmentExactRequest} [body] ShipmentRequest to be added to the requesting user\&#39;s organization.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    public createShipmentExact(body?: ShipmentExactRequest, options?: AxiosRequestConfig) {
        return ShipmentsApiFp(this.configuration).createShipmentExact(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Place a request for bulk deletion of shipments
     * @param {Array<string>} [requestBody] A JSON list of shipment Ids to delete
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    public deleteBulkShipment(requestBody?: Array<string>, options?: AxiosRequestConfig) {
        return ShipmentsApiFp(this.configuration).deleteBulkShipment(requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a shipment by its ID
     * @param {string} shipmentId ID of the shipment to be deleted
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    public deleteShipmentExactById(shipmentId: string, options?: AxiosRequestConfig) {
        return ShipmentsApiFp(this.configuration).deleteShipmentExactById(shipmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Download a CSV with shipments
     * @param {number} [limit] Number of items to limit the list by (used for pagination)
     * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
     * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
     * @param {ListAllUsersInOrganizationSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
     * @param {ListAllUsersInOrganizationSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
     * @param {boolean} [advancedSearch] Advanced search mode
     * @param {ListAllUsersInOrganizationSearchParameter} [excludedCols] Column names to be excluded from the downloaded CSV file.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    public downloadShipments(limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: ListAllUsersInOrganizationSearchParameter, searchField?: ListAllUsersInOrganizationSearchParameter, advancedSearch?: boolean, excludedCols?: ListAllUsersInOrganizationSearchParameter, options?: AxiosRequestConfig) {
        return ShipmentsApiFp(this.configuration).downloadShipments(limit, sortBy, sortDirection, search, searchField, advancedSearch, excludedCols, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Note that channelpartner is renamed to reseller, including all prefixes. The expected values for these fields remain the same.
     * @summary Get a shipment by its ID
     * @param {string} shipmentId ID of shipment to be fetched
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    public getShipmentExactById(shipmentId: string, options?: AxiosRequestConfig) {
        return ShipmentsApiFp(this.configuration).getShipmentExactById(shipmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all shipping and product refund information for a shipment
     * @summary Get refund information for a shipment
     * @param {string} shipmentId Id of shipment
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    public getShipmentRefunds(shipmentId: string, options?: AxiosRequestConfig) {
        return ShipmentsApiFp(this.configuration).getShipmentRefunds(shipmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns an array of shipment objects with IDs.  Returns all shipments a user has permission to view, including shipments to other recipients.   Because there is a 100-record limit on all API calls only the first 100 records are returned.  If there are more than 100 shipments, iterate through the shipments based on the number of shipments provided by the total_count parameter.  Use the optional offset parameter to obtain more records.  The response from the shipments_exact resource will include a shipment_id which can be used to get the tracking information for the shipment request.  Note that channelpartner is renamed to reseller, including all prefixes. The expected values for these fields remain the same. 
     * @summary List all shipments
     * @param {number} [offset] Number of items to offset the list by (used for pagination)
     * @param {number} [limit] Number of items to limit the list by (used for pagination)
     * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
     * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
     * @param {ListAllUsersInOrganizationSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
     * @param {ListAllUsersInOrganizationSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
     * @param {boolean} [advancedSearch] Advanced search mode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    public getShipmentsExact(offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: ListAllUsersInOrganizationSearchParameter, searchField?: ListAllUsersInOrganizationSearchParameter, advancedSearch?: boolean, options?: AxiosRequestConfig) {
        return ShipmentsApiFp(this.configuration).getShipmentsExact(offset, limit, sortBy, sortDirection, search, searchField, advancedSearch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Provides a description of the searchable fields on searchable resources. Returns a metadata object that describes which fields on `GET /shipments_exact` are searchable/sortable.  To enable *advanced search*, add the query string parameter \'&advanced_search=true\'. The \'&search\' query parameters must follow the structure \'search=field_name::operation_type::value\'. 
     * @summary Lists searchable fields
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    public listShipmenExactSearchDescription(options?: AxiosRequestConfig) {
        return ShipmentsApiFp(this.configuration).listShipmenExactSearchDescription(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Depending on its state, a shipment request can be edited. The states are reflected in the messages displayed in the Console, see [Shipment Status Codes](https://docs.yubico.com/cloud-services/yubienterprise/delivery/api-best-practices-faq.html#shipment-status-codes). Note that channelpartner is renamed to reseller, including all prefixes. The expected values for these fields remain the same.
     * @summary Update a shipment by its ID
     * @param {string} shipmentId ID of shipment to be fetched
     * @param {ShipmentExactRequest} [shipmentExactRequest] add complete record of the shipment to be updated
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    public updateShipmentExactById(shipmentId: string, shipmentExactRequest?: ShipmentExactRequest, options?: AxiosRequestConfig) {
        return ShipmentsApiFp(this.configuration).updateShipmentExactById(shipmentId, shipmentExactRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * UsersApi - axios parameter creator
 * @export
 */
export const UsersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Removes the association between the user and the organization, including removing roles. 
         * @summary Deletes a user from an organization
         * @param {string} userId ID of user to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserFromOrganization: async (userId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('deleteUserFromOrganization', 'userId', userId)
            const localVarPath = `/v1/users/{user_id}`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get user info
         * @param {string} userId ID of user to get info for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOneUserInOrganization: async (userId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getOneUserInOrganization', 'userId', userId)
            const localVarPath = `/v1/users/{user_id}`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a list that describes users searchable fields
         * @summary List searchable fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsersSearchDescription: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/users/search-description`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This function invites a user to join an organization and creates the user record if it does not already exist, triggering the user sign up flow. 
         * @summary Invites user to join organization
         * @param {UserInvite} body User to be invited to join organization. Roles[] is a new, experimental field.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inviteAUserToOrganization: async (body: UserInvite, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('inviteAUserToOrganization', 'body', body)
            const localVarPath = `/v1/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This API is deprecated. Use the `/users` API instead. New implementations should use the alternate API; existing code should be updated to use the alternate API. This API may be removed from availability starting November 2024.  This function invites a user to join an organization and creates the user record if it does not already exist, triggering the user sign up flow. 
         * @summary Invites user to join organization
         * @param {UserInvite} body User to be invited to join organization. Roles[] is a new, experimental field.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        inviteUserToOrganization: async (body: UserInvite, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('inviteUserToOrganization', 'body', body)
            const localVarPath = `/v1/organization/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List users in the current organization
         * @param {number} [offset] Number of items to offset the list by (used for pagination)
         * @param {number} [limit] Number of items to limit the list by (used for pagination)
         * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
         * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
         * @param {ListAllUsersInOrganizationSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
         * @param {ListAllUsersInOrganizationSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
         * @param {boolean} [advancedSearch] Advanced search mode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAllUsersInOrganization: async (offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: ListAllUsersInOrganizationSearchParameter, searchField?: ListAllUsersInOrganizationSearchParameter, advancedSearch?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "authorization", configuration)

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sort_direction'] = sortDirection;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (searchField !== undefined) {
                localVarQueryParameter['search_field'] = searchField;
            }

            if (advancedSearch !== undefined) {
                localVarQueryParameter['advanced_search'] = advancedSearch;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This API is deprecated. Use the `/users` API instead. New implementations should use the alternate API; existing code should be updated to use the alternate API. This API may be removed from availability starting November 2024.
         * @summary List users in the current organization
         * @param {number} [offset] Number of items to offset the list by (used for pagination)
         * @param {number} [limit] Number of items to limit the list by (used for pagination)
         * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
         * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
         * @param {ListAllUsersInOrganizationSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
         * @param {ListAllUsersInOrganizationSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
         * @param {boolean} [advancedSearch] Advanced search mode
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        listUsersInOrganization: async (offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: ListAllUsersInOrganizationSearchParameter, searchField?: ListAllUsersInOrganizationSearchParameter, advancedSearch?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/organization/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "authorization", configuration)

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sort_direction'] = sortDirection;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (searchField !== undefined) {
                localVarQueryParameter['search_field'] = searchField;
            }

            if (advancedSearch !== undefined) {
                localVarQueryParameter['advanced_search'] = advancedSearch;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a list that describes users searchable fields | This API is deprecated. Use the `/users/search-description` API instead. New implementations should use the alternate API; existing code should be updated to use the alternate API. This API may be removed from availability starting November 2024.
         * @summary Lists searchable fields
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        listUsersSearchDescription: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/organization/users/search-description`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This API is deprecated. Use the `/users` API instead. New implementations should use the alternate API; existing code should be updated to use the alternate API. This API may be removed from availability starting November 2024.  Removes the association between the user and the organization, including removing roles. 
         * @summary Removes a user from an organization
         * @param {string} email Email of the user to remove
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        removeUserFromOrganization: async (email: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('removeUserFromOrganization', 'email', email)
            const localVarPath = `/v1/organization/users/{email}`
                .replace(`{${"email"}}`, encodeURIComponent(String(email)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * If the request body action is \"reset-user\", the user\'s account is reset. If the request body action is \"reset-password\", the user\'s password is reset. 
         * @summary Resets a user account or user password
         * @param {string} userId ID of user to reset or reset password
         * @param {ResetAction} body Reset action to be performed. Current options are \&quot;reset-user\&quot; or \&quot;reset-password\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetAUserOrUserPassword: async (userId: string, body: ResetAction, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('resetAUserOrUserPassword', 'userId', userId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('resetAUserOrUserPassword', 'body', body)
            const localVarPath = `/v1/users/{user_id}`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This resets the user and sends out an email to that user, informing them. This means the user will be suspended and unable to login until they have gone through the account recovery process. The first step for account recovery is to follow the link in the email that was sent out. | This API is deprecated. Use the `POST /users/{user_id}` API instead. New implementations should use the alternate API; existing code should be updated to use the alternate API. This API may be removed from availability starting November 2024. 
         * @summary Resets a user and sends out a recovery email
         * @param {string} email Email of the user to reset
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        resetUserFromOrganization: async (email: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('resetUserFromOrganization', 'email', email)
            const localVarPath = `/v1/organization/users/reset/{email}`
                .replace(`{${"email"}}`, encodeURIComponent(String(email)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This resets the password of a user and sends out an email to that user, informing them. | This API is deprecated. Use the `POST /users/{user_id}` API instead. New implementations should use the alternate API; existing code should be updated to use the alternate API. This API may be removed from availability starting November 2024.
         * @summary Resets the password of a user and sends out a password reset email
         * @param {string} email Email of the user to password-reset
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        resetUserPasswordFromOrganization: async (email: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('resetUserPasswordFromOrganization', 'email', email)
            const localVarPath = `/v1/organization/users/reset-password/{email}`
                .replace(`{${"email"}}`, encodeURIComponent(String(email)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This API is deprecated. Use the `PUT /users` API instead. New implementations should use the alternate API; existing code should be updated to use the alternate API. This API may be removed from availability starting November 2024. 
         * @summary Updates the role of a user in the current organization
         * @param {string} email Email of the user to reset
         * @param {RoleOrRoles} [roleOrRoles] Role or Roles to assign to user. Roles[] is a new, experimental field.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        updateOrganizationUserRole: async (email: string, roleOrRoles?: RoleOrRoles, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('updateOrganizationUserRole', 'email', email)
            const localVarPath = `/v1/organization/users/{email}`
                .replace(`{${"email"}}`, encodeURIComponent(String(email)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(roleOrRoles, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Updates the role of a user in the current organization
         * @param {string} userId ID of the user to update the role for
         * @param {Roles} [roles] Roles to assign to user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrganizationUserRoles: async (userId: string, roles?: Roles, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('updateOrganizationUserRoles', 'userId', userId)
            const localVarPath = `/v1/users/{user_id}`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(roles, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UsersApi - functional programming interface
 * @export
 */
export const UsersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UsersApiAxiosParamCreator(configuration)
    return {
        /**
         * Removes the association between the user and the organization, including removing roles. 
         * @summary Deletes a user from an organization
         * @param {string} userId ID of user to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteUserFromOrganization(userId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteUserFromOrganization(userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get user info
         * @param {string} userId ID of user to get info for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOneUserInOrganization(userId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationUser>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOneUserInOrganization(userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns a list that describes users searchable fields
         * @summary List searchable fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUsersSearchDescription(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchDescription>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUsersSearchDescription(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This function invites a user to join an organization and creates the user record if it does not already exist, triggering the user sign up flow. 
         * @summary Invites user to join organization
         * @param {UserInvite} body User to be invited to join organization. Roles[] is a new, experimental field.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async inviteAUserToOrganization(body: UserInvite, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.inviteAUserToOrganization(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This API is deprecated. Use the `/users` API instead. New implementations should use the alternate API; existing code should be updated to use the alternate API. This API may be removed from availability starting November 2024.  This function invites a user to join an organization and creates the user record if it does not already exist, triggering the user sign up flow. 
         * @summary Invites user to join organization
         * @param {UserInvite} body User to be invited to join organization. Roles[] is a new, experimental field.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async inviteUserToOrganization(body: UserInvite, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.inviteUserToOrganization(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary List users in the current organization
         * @param {number} [offset] Number of items to offset the list by (used for pagination)
         * @param {number} [limit] Number of items to limit the list by (used for pagination)
         * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
         * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
         * @param {ListAllUsersInOrganizationSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
         * @param {ListAllUsersInOrganizationSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
         * @param {boolean} [advancedSearch] Advanced search mode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listAllUsersInOrganization(offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: ListAllUsersInOrganizationSearchParameter, searchField?: ListAllUsersInOrganizationSearchParameter, advancedSearch?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationUsersResultSet>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listAllUsersInOrganization(offset, limit, sortBy, sortDirection, search, searchField, advancedSearch, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This API is deprecated. Use the `/users` API instead. New implementations should use the alternate API; existing code should be updated to use the alternate API. This API may be removed from availability starting November 2024.
         * @summary List users in the current organization
         * @param {number} [offset] Number of items to offset the list by (used for pagination)
         * @param {number} [limit] Number of items to limit the list by (used for pagination)
         * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
         * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
         * @param {ListAllUsersInOrganizationSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
         * @param {ListAllUsersInOrganizationSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
         * @param {boolean} [advancedSearch] Advanced search mode
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async listUsersInOrganization(offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: ListAllUsersInOrganizationSearchParameter, searchField?: ListAllUsersInOrganizationSearchParameter, advancedSearch?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationUsersResultSet>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listUsersInOrganization(offset, limit, sortBy, sortDirection, search, searchField, advancedSearch, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns a list that describes users searchable fields | This API is deprecated. Use the `/users/search-description` API instead. New implementations should use the alternate API; existing code should be updated to use the alternate API. This API may be removed from availability starting November 2024.
         * @summary Lists searchable fields
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async listUsersSearchDescription(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchDescription>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listUsersSearchDescription(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This API is deprecated. Use the `/users` API instead. New implementations should use the alternate API; existing code should be updated to use the alternate API. This API may be removed from availability starting November 2024.  Removes the association between the user and the organization, including removing roles. 
         * @summary Removes a user from an organization
         * @param {string} email Email of the user to remove
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async removeUserFromOrganization(email: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeUserFromOrganization(email, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * If the request body action is \"reset-user\", the user\'s account is reset. If the request body action is \"reset-password\", the user\'s password is reset. 
         * @summary Resets a user account or user password
         * @param {string} userId ID of user to reset or reset password
         * @param {ResetAction} body Reset action to be performed. Current options are \&quot;reset-user\&quot; or \&quot;reset-password\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resetAUserOrUserPassword(userId: string, body: ResetAction, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resetAUserOrUserPassword(userId, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This resets the user and sends out an email to that user, informing them. This means the user will be suspended and unable to login until they have gone through the account recovery process. The first step for account recovery is to follow the link in the email that was sent out. | This API is deprecated. Use the `POST /users/{user_id}` API instead. New implementations should use the alternate API; existing code should be updated to use the alternate API. This API may be removed from availability starting November 2024. 
         * @summary Resets a user and sends out a recovery email
         * @param {string} email Email of the user to reset
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async resetUserFromOrganization(email: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resetUserFromOrganization(email, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This resets the password of a user and sends out an email to that user, informing them. | This API is deprecated. Use the `POST /users/{user_id}` API instead. New implementations should use the alternate API; existing code should be updated to use the alternate API. This API may be removed from availability starting November 2024.
         * @summary Resets the password of a user and sends out a password reset email
         * @param {string} email Email of the user to password-reset
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async resetUserPasswordFromOrganization(email: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resetUserPasswordFromOrganization(email, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This API is deprecated. Use the `PUT /users` API instead. New implementations should use the alternate API; existing code should be updated to use the alternate API. This API may be removed from availability starting November 2024. 
         * @summary Updates the role of a user in the current organization
         * @param {string} email Email of the user to reset
         * @param {RoleOrRoles} [roleOrRoles] Role or Roles to assign to user. Roles[] is a new, experimental field.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async updateOrganizationUserRole(email: string, roleOrRoles?: RoleOrRoles, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateOrganizationUserRole(email, roleOrRoles, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Updates the role of a user in the current organization
         * @param {string} userId ID of the user to update the role for
         * @param {Roles} [roles] Roles to assign to user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOrganizationUserRoles(userId: string, roles?: Roles, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateOrganizationUserRoles(userId, roles, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UsersApi - factory interface
 * @export
 */
export const UsersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UsersApiFp(configuration)
    return {
        /**
         * Removes the association between the user and the organization, including removing roles. 
         * @summary Deletes a user from an organization
         * @param {string} userId ID of user to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserFromOrganization(userId: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteUserFromOrganization(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get user info
         * @param {string} userId ID of user to get info for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOneUserInOrganization(userId: string, options?: any): AxiosPromise<OrganizationUser> {
            return localVarFp.getOneUserInOrganization(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a list that describes users searchable fields
         * @summary List searchable fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsersSearchDescription(options?: any): AxiosPromise<SearchDescription> {
            return localVarFp.getUsersSearchDescription(options).then((request) => request(axios, basePath));
        },
        /**
         * This function invites a user to join an organization and creates the user record if it does not already exist, triggering the user sign up flow. 
         * @summary Invites user to join organization
         * @param {UserInvite} body User to be invited to join organization. Roles[] is a new, experimental field.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inviteAUserToOrganization(body: UserInvite, options?: any): AxiosPromise<void> {
            return localVarFp.inviteAUserToOrganization(body, options).then((request) => request(axios, basePath));
        },
        /**
         * This API is deprecated. Use the `/users` API instead. New implementations should use the alternate API; existing code should be updated to use the alternate API. This API may be removed from availability starting November 2024.  This function invites a user to join an organization and creates the user record if it does not already exist, triggering the user sign up flow. 
         * @summary Invites user to join organization
         * @param {UserInvite} body User to be invited to join organization. Roles[] is a new, experimental field.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        inviteUserToOrganization(body: UserInvite, options?: any): AxiosPromise<void> {
            return localVarFp.inviteUserToOrganization(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List users in the current organization
         * @param {number} [offset] Number of items to offset the list by (used for pagination)
         * @param {number} [limit] Number of items to limit the list by (used for pagination)
         * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
         * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
         * @param {ListAllUsersInOrganizationSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
         * @param {ListAllUsersInOrganizationSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
         * @param {boolean} [advancedSearch] Advanced search mode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAllUsersInOrganization(offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: ListAllUsersInOrganizationSearchParameter, searchField?: ListAllUsersInOrganizationSearchParameter, advancedSearch?: boolean, options?: any): AxiosPromise<OrganizationUsersResultSet> {
            return localVarFp.listAllUsersInOrganization(offset, limit, sortBy, sortDirection, search, searchField, advancedSearch, options).then((request) => request(axios, basePath));
        },
        /**
         * This API is deprecated. Use the `/users` API instead. New implementations should use the alternate API; existing code should be updated to use the alternate API. This API may be removed from availability starting November 2024.
         * @summary List users in the current organization
         * @param {number} [offset] Number of items to offset the list by (used for pagination)
         * @param {number} [limit] Number of items to limit the list by (used for pagination)
         * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
         * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
         * @param {ListAllUsersInOrganizationSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
         * @param {ListAllUsersInOrganizationSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
         * @param {boolean} [advancedSearch] Advanced search mode
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        listUsersInOrganization(offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: ListAllUsersInOrganizationSearchParameter, searchField?: ListAllUsersInOrganizationSearchParameter, advancedSearch?: boolean, options?: any): AxiosPromise<OrganizationUsersResultSet> {
            return localVarFp.listUsersInOrganization(offset, limit, sortBy, sortDirection, search, searchField, advancedSearch, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a list that describes users searchable fields | This API is deprecated. Use the `/users/search-description` API instead. New implementations should use the alternate API; existing code should be updated to use the alternate API. This API may be removed from availability starting November 2024.
         * @summary Lists searchable fields
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        listUsersSearchDescription(options?: any): AxiosPromise<SearchDescription> {
            return localVarFp.listUsersSearchDescription(options).then((request) => request(axios, basePath));
        },
        /**
         * This API is deprecated. Use the `/users` API instead. New implementations should use the alternate API; existing code should be updated to use the alternate API. This API may be removed from availability starting November 2024.  Removes the association between the user and the organization, including removing roles. 
         * @summary Removes a user from an organization
         * @param {string} email Email of the user to remove
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        removeUserFromOrganization(email: string, options?: any): AxiosPromise<void> {
            return localVarFp.removeUserFromOrganization(email, options).then((request) => request(axios, basePath));
        },
        /**
         * If the request body action is \"reset-user\", the user\'s account is reset. If the request body action is \"reset-password\", the user\'s password is reset. 
         * @summary Resets a user account or user password
         * @param {string} userId ID of user to reset or reset password
         * @param {ResetAction} body Reset action to be performed. Current options are \&quot;reset-user\&quot; or \&quot;reset-password\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetAUserOrUserPassword(userId: string, body: ResetAction, options?: any): AxiosPromise<void> {
            return localVarFp.resetAUserOrUserPassword(userId, body, options).then((request) => request(axios, basePath));
        },
        /**
         * This resets the user and sends out an email to that user, informing them. This means the user will be suspended and unable to login until they have gone through the account recovery process. The first step for account recovery is to follow the link in the email that was sent out. | This API is deprecated. Use the `POST /users/{user_id}` API instead. New implementations should use the alternate API; existing code should be updated to use the alternate API. This API may be removed from availability starting November 2024. 
         * @summary Resets a user and sends out a recovery email
         * @param {string} email Email of the user to reset
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        resetUserFromOrganization(email: string, options?: any): AxiosPromise<void> {
            return localVarFp.resetUserFromOrganization(email, options).then((request) => request(axios, basePath));
        },
        /**
         * This resets the password of a user and sends out an email to that user, informing them. | This API is deprecated. Use the `POST /users/{user_id}` API instead. New implementations should use the alternate API; existing code should be updated to use the alternate API. This API may be removed from availability starting November 2024.
         * @summary Resets the password of a user and sends out a password reset email
         * @param {string} email Email of the user to password-reset
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        resetUserPasswordFromOrganization(email: string, options?: any): AxiosPromise<void> {
            return localVarFp.resetUserPasswordFromOrganization(email, options).then((request) => request(axios, basePath));
        },
        /**
         * This API is deprecated. Use the `PUT /users` API instead. New implementations should use the alternate API; existing code should be updated to use the alternate API. This API may be removed from availability starting November 2024. 
         * @summary Updates the role of a user in the current organization
         * @param {string} email Email of the user to reset
         * @param {RoleOrRoles} [roleOrRoles] Role or Roles to assign to user. Roles[] is a new, experimental field.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        updateOrganizationUserRole(email: string, roleOrRoles?: RoleOrRoles, options?: any): AxiosPromise<void> {
            return localVarFp.updateOrganizationUserRole(email, roleOrRoles, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Updates the role of a user in the current organization
         * @param {string} userId ID of the user to update the role for
         * @param {Roles} [roles] Roles to assign to user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrganizationUserRoles(userId: string, roles?: Roles, options?: any): AxiosPromise<void> {
            return localVarFp.updateOrganizationUserRoles(userId, roles, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UsersApi - object-oriented interface
 * @export
 * @class UsersApi
 * @extends {BaseAPI}
 */
export class UsersApi extends BaseAPI {
    /**
     * Removes the association between the user and the organization, including removing roles. 
     * @summary Deletes a user from an organization
     * @param {string} userId ID of user to delete
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public deleteUserFromOrganization(userId: string, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).deleteUserFromOrganization(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get user info
     * @param {string} userId ID of user to get info for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public getOneUserInOrganization(userId: string, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).getOneUserInOrganization(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a list that describes users searchable fields
     * @summary List searchable fields
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public getUsersSearchDescription(options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).getUsersSearchDescription(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This function invites a user to join an organization and creates the user record if it does not already exist, triggering the user sign up flow. 
     * @summary Invites user to join organization
     * @param {UserInvite} body User to be invited to join organization. Roles[] is a new, experimental field.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public inviteAUserToOrganization(body: UserInvite, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).inviteAUserToOrganization(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This API is deprecated. Use the `/users` API instead. New implementations should use the alternate API; existing code should be updated to use the alternate API. This API may be removed from availability starting November 2024.  This function invites a user to join an organization and creates the user record if it does not already exist, triggering the user sign up flow. 
     * @summary Invites user to join organization
     * @param {UserInvite} body User to be invited to join organization. Roles[] is a new, experimental field.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public inviteUserToOrganization(body: UserInvite, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).inviteUserToOrganization(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List users in the current organization
     * @param {number} [offset] Number of items to offset the list by (used for pagination)
     * @param {number} [limit] Number of items to limit the list by (used for pagination)
     * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
     * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
     * @param {ListAllUsersInOrganizationSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
     * @param {ListAllUsersInOrganizationSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
     * @param {boolean} [advancedSearch] Advanced search mode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public listAllUsersInOrganization(offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: ListAllUsersInOrganizationSearchParameter, searchField?: ListAllUsersInOrganizationSearchParameter, advancedSearch?: boolean, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).listAllUsersInOrganization(offset, limit, sortBy, sortDirection, search, searchField, advancedSearch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This API is deprecated. Use the `/users` API instead. New implementations should use the alternate API; existing code should be updated to use the alternate API. This API may be removed from availability starting November 2024.
     * @summary List users in the current organization
     * @param {number} [offset] Number of items to offset the list by (used for pagination)
     * @param {number} [limit] Number of items to limit the list by (used for pagination)
     * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
     * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
     * @param {ListAllUsersInOrganizationSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
     * @param {ListAllUsersInOrganizationSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
     * @param {boolean} [advancedSearch] Advanced search mode
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public listUsersInOrganization(offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: ListAllUsersInOrganizationSearchParameter, searchField?: ListAllUsersInOrganizationSearchParameter, advancedSearch?: boolean, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).listUsersInOrganization(offset, limit, sortBy, sortDirection, search, searchField, advancedSearch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a list that describes users searchable fields | This API is deprecated. Use the `/users/search-description` API instead. New implementations should use the alternate API; existing code should be updated to use the alternate API. This API may be removed from availability starting November 2024.
     * @summary Lists searchable fields
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public listUsersSearchDescription(options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).listUsersSearchDescription(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This API is deprecated. Use the `/users` API instead. New implementations should use the alternate API; existing code should be updated to use the alternate API. This API may be removed from availability starting November 2024.  Removes the association between the user and the organization, including removing roles. 
     * @summary Removes a user from an organization
     * @param {string} email Email of the user to remove
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public removeUserFromOrganization(email: string, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).removeUserFromOrganization(email, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * If the request body action is \"reset-user\", the user\'s account is reset. If the request body action is \"reset-password\", the user\'s password is reset. 
     * @summary Resets a user account or user password
     * @param {string} userId ID of user to reset or reset password
     * @param {ResetAction} body Reset action to be performed. Current options are \&quot;reset-user\&quot; or \&quot;reset-password\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public resetAUserOrUserPassword(userId: string, body: ResetAction, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).resetAUserOrUserPassword(userId, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This resets the user and sends out an email to that user, informing them. This means the user will be suspended and unable to login until they have gone through the account recovery process. The first step for account recovery is to follow the link in the email that was sent out. | This API is deprecated. Use the `POST /users/{user_id}` API instead. New implementations should use the alternate API; existing code should be updated to use the alternate API. This API may be removed from availability starting November 2024. 
     * @summary Resets a user and sends out a recovery email
     * @param {string} email Email of the user to reset
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public resetUserFromOrganization(email: string, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).resetUserFromOrganization(email, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This resets the password of a user and sends out an email to that user, informing them. | This API is deprecated. Use the `POST /users/{user_id}` API instead. New implementations should use the alternate API; existing code should be updated to use the alternate API. This API may be removed from availability starting November 2024.
     * @summary Resets the password of a user and sends out a password reset email
     * @param {string} email Email of the user to password-reset
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public resetUserPasswordFromOrganization(email: string, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).resetUserPasswordFromOrganization(email, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This API is deprecated. Use the `PUT /users` API instead. New implementations should use the alternate API; existing code should be updated to use the alternate API. This API may be removed from availability starting November 2024. 
     * @summary Updates the role of a user in the current organization
     * @param {string} email Email of the user to reset
     * @param {RoleOrRoles} [roleOrRoles] Role or Roles to assign to user. Roles[] is a new, experimental field.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public updateOrganizationUserRole(email: string, roleOrRoles?: RoleOrRoles, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).updateOrganizationUserRole(email, roleOrRoles, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Updates the role of a user in the current organization
     * @param {string} userId ID of the user to update the role for
     * @param {Roles} [roles] Roles to assign to user.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public updateOrganizationUserRoles(userId: string, roles?: Roles, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).updateOrganizationUserRoles(userId, roles, options).then((request) => request(this.axios, this.basePath));
    }
}


